const examQuestions = [
  {
    id: 1,
    question: "Bronią w rozumieniu ustawy o broni i amunicji nie jest:",
    answers: {
      a: "broń palna",
      b: "broń pneumatyczna",
      c: "broń ostra",
    },
    correct: "c",
    explain: {
      a: "Bronią palna jest zdefiniowana jako broń w ustawie, dlatego odpowiedź 'a' jest nieprawidłowa.",
      b: "Broń pneumatyczna, chociaż ma mniejszą siłę, również jest uznawana za broń w rozumieniu ustawy, więc odpowiedź 'b' jest nieprawidłowa.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ 'broń ostra' nie jest uznawana za kategorię broni w rozumieniu ustawy, która obejmuje inne typy broni takie jak broń palna i pneumatyczna.",
  },
  {
    id: 2,
    question: "Bronią w rozumieniu ustawy o broni i amunicji jest:",
    answers: {
      a: "miotacz gazu obezwładniającego",
      b: "miotacz gazu łzawiącego",
      c: "miotacz gazu pieprzowego",
    },
    correct: "a",
    explain: {
      b: "Miotacz gazu łzawiącego nie jest osobno wymieniony jako broń, co czyni odpowiedź 'b' nieprawidłową.",
      c: "Miotacz gazu pieprzowego również nie jest klasyfikowany jako broń w rozumieniu ustawy, więc odpowiedź 'c' jest nieprawidłowa.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ ustawa wyraźnie definiuje miotacz gazu obezwładniającego jako broń.",
  },
  {
    id: 3,
    question: "Bronią w rozumieniu ustawy o broni i amunicji nie jest:",
    answers: {
      a: "kastet",
      b: "nóż",
      c: "pałka wykonana z drewna lub innego ciężkiego i twardego materiału, imitująca kij bejsbolowy",
    },
    correct: "b",
    explain: {
      a: "Kastet jest uznawany za broń, ponieważ jest to narzędzie używane do zadawania obrażeń.",
      c: "pałka wykonana z drewna lub innego ciężkiego i twardego materiału, imitująca kij bejsbolowy jest ujęta w ustawie jako broń",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ niezależnie od swojej konstrukcji (np. nóż ze stałą głownią, nóż składany, nóż motylkowy czy nóż sprężynowy) nie podlega on ustawie o broni i amunicji.",
  },
  {
    id: 4,
    question: "Bronią w rozumieniu ustawy o broni i amunicji jest:",
    answers: {
      a: "broń cięciwowa w postaci łuku",
      b: "proca",
      c: "broń cięciwowa w postaci kuszy",
    },
    correct: "c",
    explain: {
      a: "Łuk, mimo że jest bronią cięciwową, nie jest klasyfikowany jako broń w rozumieniu tej ustawy.",
      b: "Proca nie jest uznawana za broń w kontekście ustawy, więc odpowiedź 'b' jest błędna.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ kusza jest uznawana za broń cięciwową w rozumieniu ustawy o broni i amunicji.",
  },
  {
    id: 5,
    question: "Amunicją, w rozumieniu ustawy o broni i amunicji, są:",
    answers: {
      a: "naboje przeznaczone do strzelania z broni palnej",
      b: "naboje przeznaczone do strzelania z broni pneumatycznej",
      c: "wszystkie naboje, bez względu na ich przeznaczenie",
    },
    correct: "a",
    explain: {
      b: "Naboje do broni pneumatycznej nie są uznawane za amunicję w rozumieniu ustawy, dlatego odpowiedź 'b' jest nieprawidłowa.",
      c: "Nie wszystkie naboje są uznawane za amunicję według ustawy, więc odpowiedź 'c' jest nieprawidłowa.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ tylko naboje przeznaczone do strzelania z broni palnej są uznawane za amunicję w rozumieniu ustawy.",
  },
  {
    id: 6,
    question:
      "Istotną czescią broni palnej, w rozumieniu ustawy o broni i amunicji, nie jest: (art. 5 ust. 2 uobia)",
    answers: {
      a: "komora zamkowa",
      b: "lufa z komorą zamkową",
      c: "magazynek",
    },
    correct: "c",
    explain: {
      a: "Komora zamkowa jest istotną częścią broni",
      b: "Lufa z komorą zamkową jest istotną częścią broni",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ magazynek nie stanowi istotnej części broni.",
  },
  {
    id: 7,
    question:
      "Istotną czescią broni palnej, w rozumieniu ustawy o broni i amunicji, jest: (art. 5 ust. 2 uobia)",
    answers: {
      a: "szczerbinka",
      b: "sprężyna powrotna",
      c: "szkielet broni",
    },
    correct: "c",
    explain: {
      a: "szczerbinka nie jest istotną częścią broni.",
      b: "sprężyna powrotna nie jest istotną częścią broni.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ szkielet broni jest jej istotną częścią.",
  },
  {
    id: 8,
    question:
      "Istotną czescią broni palnej, w rozumieniu ustawy o broni i amunicji, nie jest: (art. 5 ust. 2 uobia)",
    answers: {
      a: "tłumik",
      b: "lufa z komorą nabojową",
      c: "zamek",
    },
    correct: "a",
    explain: {
      b: "lufa z komorą nabojową jest istotną częścią broni.",
      c: "zamek jest istotną częścią broni.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ tłumik huku nie jest istotną częścią broni.",
  },
  {
    id: 9,
    question:
      "Istotną czescią broni palnej, w rozumieniu ustawy o broni i amunicji, nie jest: (art. 5 ust. 2 uobia)",
    answers: {
      a: "baskila",
      b: "kolba",
      c: "zamek",
    },
    correct: "b",
    explain: {
      a: "baskila jest istotną częścią broni palnej.",
      c: "zamek jest istotną częścią broni palnej.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ kolba nie jest istotną częścią broni palnej.",
  },
  {
    id: 10,
    question:
      "Istotna czescia broni palnej, w rozumieniu ustawy o broni i amunicji, jest: (art. 5 ust. 2 uobia)",
    answers: {
      a: "bęben nabojowy",
      b: "rękojeść",
      c: "muszka",
    },
    correct: "a",
    explain: {
      b: "rękojeść nie jest istotną częścią broni.",
      c: "muszka nie jest istotną częścią broni.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ bęben nabojowy zgodnie z ustawą uznany jest za istotną część broni.",
  },
  {
    id: 11,
    question:
      "Istotną częścią amunicji, w rozumieniu ustawy o broni i amunicji, jest: (art. 5 ust. 3 uobia)",
    answers: {
      a: "śrut strzelecki",
      b: "materiał miotający w postaci prochu strzelniczego",
      c: "odpowiedzi a. i b. są nieprawidłowe.",
    },
    correct: "b",
    explain: {
      a: "śrut strzelecki nie jest istotną częścią amunicji.",
      c: "tylko odpowiedź 'a' jest nieprawidłowa.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ materiał miotający w postaci prochu strzelniczego jest istotną częścią amunicji.",
  },
  {
    id: 12,
    question:
      "Istotną częścią amunicji, w rozumieniu ustawy o broni i amunicji, nie jest: (art. 5 ust.3 uobia)",
    answers: {
      a: "spłonka inicjująca spalanie materiału miotającego",
      b: "pocisk wypełniony materiałami wybuchowymi, chemicznymi środkami obezwładniającymi lub zapalającymi albo innymi substancjami, których działanie zagraża życiu lub zdrowiu",
      c: "łuska łącząca w całość inne elementy naboju",
    },
    correct: "c",
    explain: {
      a: "Spłonka inicjująca spalanie materiału miotającego jest istotną częścią amunicji.",
      b: "pocisk wypełniony materiałami wybuchowymi, chemicznymi środkami obezwładniającymi lub zapalającymi albo innymi substancjami, których działanie zagraża życiu lub zdrowiu jest istotną częścią amunicji.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ łuska nie stanowi według ustawy istotnej części amunicji.",
  },
  {
    id: 13,
    question:
      "Dokonywanie przeróbek broni zmieniających jej rodzaj, kaliber lub przeznaczenie, bez wymaganego zezwolenia, jest: (art. 6 ust. 2 uobia)",
    answers: {
      a: "wykroczeniem",
      b: "przestępstwem",
      c: "odpowiedzi a i b są nieprawidłowe",
    },
    correct: "b",
    explain: {
      a: "Dokonywanie przeróbek broni zmieniających jej rodzaj, kaliber lub przeznaczenie, bez wymaganego zezwolenia, jest przestępstwem, a nie wykroczeniem.",
      c: "Tylko odpowiedź a jest nieprawidłowa.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ dokonywanie przeróbek broni zmieniających jej rodzaj, kaliber lub przeznaczenie, bez wymaganego zezwolenia, jest przestępstwem",
  },
  {
    id: 14,
    question:
      "Dokonywanie przeróbek broni zmieniających jej rodzaj, kaliber lub przeznaczenie, bez wymaganego zezwolenia, jest: (art. 6 ust. 2 uobia)",
    answers: {
      a: "dozwolone wyłącznie wówczas, gdy posiadacz pozwolenia na broń jest uprawniony do posiadania również broni, która powstanie po przeróbce",
      b: "zabronione",
      c: "dozwolone wyłącznie wówczas, gdy zezwala na to specyfikacja techniczna broni, a dokonana przeróbka nie wpłynie na bezpieczeństwo podczas używania broni",
    },
    correct: "b",
    explain: {
      a: "dokonywanie przeróbek broni zmieniających jej rodzaj, kaliber lub przeznaczenie, bez wymaganego zezwolenia, jest zabronione.",
      c: "dokonywanie przeróbek broni zmieniających jej rodzaj, kaliber lub przeznaczenie, bez wymaganego zezwolenia, jest zabronione.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ dokonywanie przeróbek broni zmieniających jej rodzaj, kaliber lub przeznaczenie, bez wymaganego zezwolenia, jest zabronione.",
  },
  {
    id: 15,
    question:
      "Bronią palna, w rozumieniu ustawy o broni i amunicji, jest: (art. 7 ust. 1 uobia)",
    answers: {
      a: "bron lufowa, która jest przenosna",
      b: "bron lufowa, która jest stacjonarna",
      c: "odpowiedzi a. i b. sa prawidlowe",
    },
    correct: "a",
    explain: {
      b: "broń palna zdefiniowana została jako każda przenośna broń lufowa, więc broń stacjonarna to nieprawidłowa odpowiedź.",
      c: "tylko odpowiedź b jest nieprawidłowa.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ broń palna zdefiniowana została jako każda przenośna broń lufowa, która miota, jest przeznaczona do miotania lub może być przystosowana do miotania jednego lub większej liczby pocisków lub substancji w wyniku działania materiału miotającego.",
  },
  {
    id: 16,
    question:
      "Bronią palną, w rozumieniu ustawy o broni i amunicji, jest: (art. 7 ust. 1 uobia)",
    answers: {
      a: "broń, która jest przystosowana do miotania jednego lub wiekszej liczby pocisków w wyniku działania sprężonego gazu",
      b: "broń, która jest przystosowana do miotania jednego lub wiekszej liczby pocisków w wyniku działania materialu miotajacego",
      c: "broń, która jest przystosowana do miotania jednego lub wiekszej liczby pocisków w wyniku działania energii elektrycznej.",
    },
    correct: "b",
    explain: {
      a: "W rozumieniu ustawy bronią palną jest każda przenośna broń lufowa, która miota, jest przeznaczona do miotania lub może być przystosowana do miotania jednego lub większej liczby pocisków lub substancji w wyniku działania materiału miotającego, a nie działania sprężonego gazu",
      c: "W rozumieniu ustawy bronią palną jest każda przenośna broń lufowa, która miota, jest przeznaczona do miotania lub może być przystosowana do miotania jednego lub większej liczby pocisków lub substancji w wyniku działania materiału miotającego, a nie działania energii elektrycznej",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ W rozumieniu ustawy bronią palną jest każda przenośna broń lufowa, która miota, jest przeznaczona do miotania lub może być przystosowana do miotania jednego lub większej liczby pocisków lub substancji w wyniku działania materiału miotającego",
  },
  {
    id: 17,
    question:
      "Bronią palną, w rozumieniu ustawy o broni i amunicji nie jest: (art. 7 ust. 1 uobia):",
    answers: {
      a: "strzelba gładkolufowa",
      b: "karabinek pneumatyczny",
      c: "pistolet sygnałowy",
    },
    correct: "b",
    explain: {
      a: "strzelba gładkolufowa w rozumieniu ustawy jest bronią palną.",
      c: "pistolet sygnałowy w rozumieniu ustawy jest bronią palną.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z ustawą karabinek pneumatyczny nie jest bronią palną",
  },
  {
    id: 18,
    question:
      "Bronią palną sygnałową, w rozumieniu ustawy o broni i amunicji, jest urządzenie wielokrotnego użycia, które w wyniku działania sprężonych gazów, powstajacych na skutek spalania materiału miotającego, jest zdolne do wystrzelenia substancji w postaci ładunku pirotechnicznego celem wywołania efektu wizualnego lub akustycznego z lufy o kalibrze: (art. 7 ust. 2 uobia)",
    answers: {
      a: "nie mniejszym niz 25 mm",
      b: "nie mniejszym niz 12 mm",
      c: "nie mniejszym niz 6 mm",
    },
    correct: "a",
    explain: {
      b: "zgodnie z ustawą bronią palną sygnałową jest urządenie o kalibrze lufy nie mniejszym niż 25 mm",
      c: "zgodnie z ustawą bronią palną sygnałową jest urządenie o kalibrze lufy nie mniejszym niż 25 mm",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z ustawą bronią palną sygnałową jest urządenie o kalibrze lufy nie mniejszym niż 25 mm",
  },
  {
    id: 19,
    question:
      "Bronią palną alarmową, w rozumieniu ustawy o broni i amunicji, jest: (art. 7 ust. 3 uobia)",
    answers: {
      a: "urządzenie wielokrotnego użycia, które w wyniku działania sprężonych gazów, powstajacych na skutek spalania materiału miotającego, wywołuje efekt wizualny,a wystrzelona z lufy lub elementu ją zastepującego substancja razi cel na odległość nie wiekszą niż 2 metry;",
      b: "urządzenie wielokrotnego użycia, które w wyniku działania sprężonych gazów, powstajacych na skutek spalania materiału miotającego, wywołuje efekt wizualny i akustyczny, a wystrzelona z lufy lub elementu ja zastepującego substancja razi cel na odległość nie większa niż 3 metry;",
      c: "urządzenie wielokrotnego użycia, które w wyniku działania sprężonych gazów, powstajacych na skutek spalania materiału miotającego, wywołuje efekt akustyczny, a wystrzelona z lufy lub elementu ją zastepującego substancja razi cel na odległość nie większa niż 1 metr.",
    },
    correct: "c",
    explain: {
      a: "W rozumieniu ustawy bronią palną alarmową jest urządzenie wielokrotnego użycia, które w wyniku działania sprężonych gazów, powstających na skutek spalania materiału miotającego, wywołuje efekt akustyczny, a wystrzelona z lufy lub elementu ją zastępującego substancja razi cel na odległość nie większą niż 1 metr.",
      b: "W rozumieniu ustawy bronią palną alarmową jest urządzenie wielokrotnego użycia, które w wyniku działania sprężonych gazów, powstających na skutek spalania materiału miotającego, wywołuje efekt akustyczny, a wystrzelona z lufy lub elementu ją zastępującego substancja razi cel na odległość nie większą niż 1 metr.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ w rozumieniu ustawy bronią palną alarmową jest urządzenie wielokrotnego użycia, które w wyniku działania sprężonych gazów, powstających na skutek spalania materiału miotającego, wywołuje efekt akustyczny, a wystrzelona z lufy lub elementu ją zastępującego substancja razi cel na odległość nie większą niż 1 metr.",
  },
  {
    id: 20,
    question:
      "Bronią pneumatyczną, w rozumieniu ustawy o broni i amunicji, jest: (art. 8 uobia)",
    answers: {
      a: "urządzenie zdolne do rażenia celów na odległość, pociskiem wystrzeliwanym z lufy lub elementu ją zastepującego z energią kinetyczną przekraczającą 17 J",
      b: "urządzenie zdolne do rażenia celów na odległość, pociskiem wystrzeliwanym z lufy lub elementu ją zastepującego z energią kinetyczną przekraczającą 15 J",
      c: "urządzenie zdolne do rażenia celów na odległość, pociskiem wystrzeliwanym z lufy lub elementu ją zastepującego z energią kinetyczną przekraczającą 13 J",
    },
    correct: "a",
    explain: {
      b: "bronią pneumatyczną jest niebezpieczne dla życia lub zdrowia urządzenie, które w wyniku działania sprężonego gazu jest zdolne do wystrzelenia pocisku z lufy lub elementu ją zastępującego i przez to zdolne do rażenia celu na odległość, a energia kinetyczna pocisku opuszczającego lufę lub element ją zastępujący przekracza 17 J",
      c: "bronią pneumatyczną jest niebezpieczne dla życia lub zdrowia urządzenie, które w wyniku działania sprężonego gazu jest zdolne do wystrzelenia pocisku z lufy lub elementu ją zastępującego i przez to zdolne do rażenia celu na odległość, a energia kinetyczna pocisku opuszczającego lufę lub element ją zastępujący przekracza 17 J",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ w rozumieniu ustawy bronią pneumatyczną jest niebezpieczne dla życia lub zdrowia urządzenie, które w wyniku działania sprężonego gazu jest zdolne do wystrzelenia pocisku z lufy lub elementu ją zastępującego i przez to zdolne do rażenia celu na odległość, a energia kinetyczna pocisku opuszczającego lufę lub element ją zastępujący przekracza 17 J.",
  },
  {
    id: 21,
    question: "Pozwolenie na broń palną wydaje: (art. 9 ust. 1 uobia)",
    answers: {
      a: "komendant wojewódzki Policji właściwy ze względu na siedzibę zainteresowanego podmiotu",
      b: "komendant powiatowy Policji właściwy ze względu na siedzibę zainteresowanego podmiotu",
      c: "komendant wojewódzki Policji lub komendant oddziału Żandarmerii Wojskowej, własciwy ze względu na siedzibę zainteresowanego podmiotu",
    },
    correct: "c",
    explain: {
      a: "Pozwolenie może być również wydane przez Komendanta oddziału Żandarmerii Wojskowej, jeśli podmiot jest żołnierzem.",
      b: "Komendant Powiatowy Policji nie wydaje pozwolenia na broń.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ pozwolenie na broń wydaje  właściwy ze względu na miejsce stałego pobytu zainteresowanej osoby lub siedzibę zainteresowanego podmiotu komendant wojewódzki Policji, a w przypadku żołnierzy zawodowych – na podstawie pozwolenia wydanego przez właściwego komendanta oddziału Żandarmerii Wojskowej.",
  },
  {
    id: 22,
    question:
      "Pozwolenie na broń zwane świadectwem broni wydaje: (art. 9 ust. 1 uobia)",
    answers: {
      a: "komendant wojewódzki Policji właściwy ze względu na siedzibę zainteresowanego podmiotu",
      b: "komendant powiatowy Policji właściwy ze względu na siedzibę zainteresowanego podmiotu",
      c: "komendant wojewódzki Policji lub komendant oddziału Żandarmerii Wojskowej, własciwy ze względu na siedzibę zainteresowanego podmiotu",
    },
    correct: "c",
    explain: {
      a: "Pozwolenie może być również wydane przez Komendanta oddziału Żandarmerii Wojskowej, jeśli podmiot jest żołnierzem.",
      b: "Komendant Powiatowy Policji nie wydaje pozwolenia na broń.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ pozwolenie na broń wydaje  właściwy ze względu na miejsce stałego pobytu zainteresowanej osoby lub siedzibę zainteresowanego podmiotu komendant wojewódzki Policji, a w przypadku żołnierzy zawodowych – na podstawie pozwolenia wydanego przez właściwego komendanta oddziału Żandarmerii Wojskowej.",
  },
  {
    id: 23,
    question:
      "Kartę rejestracyjną broni pozbawionej cech użytkowych wydaje: (art. 9 ust. 2 uobia)",
    answers: {
      a: "komendant wojewódzki Policji właściwy ze względu na miejsce czasowego pobytu zainteresowanej osoby",
      b: "komendant wojewódzki Policji własciwy ze względu na miejsce zameldowania zainteresowanej osoby",
      c: "komendant wojewódzki Policji własciwy ze względu na miejsce stałego pobytu zainteresowanej osoby",
    },
    correct: "c",
    explain: {
      a: "we wskazanym art. ustawy mowa jest o miejscu stałego, a nie czasowego pobytu.",
      b: "we wskazanym art. ustawy mowa jest mowa o miejscu stałego pobytu, a nie zameldowania.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ w ustawie wymienione jest stałe miejsce pobytu zainteresowanej osoby.",
  },
  {
    id: 24,
    question:
      "Pozwolenie na miotacz gazu obezwładniającego wydaje: (art. 9 ust. 3 uobia)",
    answers: {
      a: "komendant powiatowy Policji właściwy ze względu na miejsce stałego pobytu zainteresowanej osoby",
      b: "komendant powiatowy Policji właściwy ze względu na miejsce czasowego pobytu zainteresowanej osoby",
      c: "komendant powiatowy Policji właściwy ze względu na miejsce zameldowania zainteresowanej osoby",
    },
    correct: "a",
    explain: {
      b: "we wskazanym art. ustawy mowa jest o miejscu stałego, a nie czasowego pobytu.",
      c: "we wskazanym art. ustawy mowa jest mowa o miejscu stałego pobytu, a nie zameldowania.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ w ustawie wymienione jest stałe miejsce pobytu zainteresowanej osoby.",
  },
  {
    id: 25,
    question:
      "Kartę rejestracyjną broni pneumatycznej wydaje: (art. 9 ust. 4 uobia)",
    answers: {
      a: "komendant powiatowy Policji właściwy ze względu na miejsce czasowego pobytu zainteresowanej osoby",
      b: "komendant powiatowy Policji właściwy ze względu na miejsce stałego pobytu zainteresowanej osoby",
      c: "komendant powiatowy Policji właściwy ze względu na miejsce zameldowania zainteresowanej osoby",
    },
    correct: "b",
    explain: {
      a: "we wskazanym art. ustawy mowa jest o miejscu stałego, a nie czasowego pobytu.",
      c: "we wskazanym art. ustawy mowa jest mowa o miejscu stałego pobytu, a nie zameldowania.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ w ustawie wymienione jest stałe miejsce pobytu zainteresowanej osoby.",
  },
  {
    id: 26,
    question: "Pozwolenie na broń wydawane jest: (art. 9 ust. 6 uobia)",
    answers: {
      a: "na czas nieokreślony",
      b: "na 5 lat",
      c: "na 3 lata",
    },
    correct: "a",
    explain: {
      b: "pozwolenie na broń wydawane jest na czas nieokreślony, a nie na 5 lat.",
      c: "pozwolenie na broń wydawane jest na czas nieokreślony, a nie na 3 lata.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ pozwolenie na broń zgodnie z ustawą wydawane jest na czas nieokreślony.",
  },
  {
    id: 27,
    question:
      "Dopuszczenie do posiadania broni wydawane jest: (art. 9 ust. 6 i art. 30 ust. 2 uobia)",
    answers: {
      a: "na 5 lat",
      b: "na czas nieokreślony",
      c: "na 3 lata",
    },
    correct: "b",
    explain: {
      a: "dopuszczenie do posiadania broni wydawane jest na czas nieokreślony, a nie na 5 lat.",
      c: "dopuszczenie do posiadania broni wydawane jest na czas nieokreślony, a nie na 3 lata.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ dopuszczenie do posiadania broni zgodnie z ustawą wydawane jest na czas nieokreślony.",
  },
  {
    id: 28,
    question:
      "Karta rejestracyjna broni palnej pozbawionej cech użytkowych wydawana jest: (art. 9 ust. 6 uobia)",
    answers: {
      a: "na 3 lata",
      b: "na 5 lat",
      c: "na czas nieokreślony",
    },
    correct: "c",
    explain: {
      a: "karta rejestracyjna broni pozbawionej cech użytkowych jest wydawana na czas nieokreślony, a nie na 3 lata.",
      b: "karta rejestracyjna broni pozbawionej cech użytkowych jest wydawana na czas nieokreślony, a nie na 5 lat.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ karta rejestracyjna broni palnej pozbawionej cech użytkowych zgodnie z ustawą wydawana jest na czas nieokreślony.",
  },
  {
    id: 29,
    question:
      "Karta rejestracyjna broni pneumatycznej wydawana jest: (art. 9 ust. 6 uobia)",
    answers: {
      a: "na czas nieokreślony",
      b: "na 3 lata",
      c: "na 5 lat",
    },
    correct: "a",
    explain: {
      b: "karta rejestracyjna broni pneumatycznej jest wydawana na czas nieokreślony, a nie na 3 lata.",
      c: "karta rejestracyjna broni pneumatycznej jest wydawana na czas nieokreślony, a nie na 5 lat.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ karta rejestracyjna broni pneumatycznej zgodnie z ustawą wydawana jest na czas nieokreślony.",
  },
  {
    id: 30,
    question:
      "Pozwolenie na broń palną bojową wydane w celu ochrony osobistej stanowi jednoczesnie pozwolenie na: (art. 9 ust. 7 uobia)",
    answers: {
      a: "broń sportową",
      b: "broń gazową i alarmową",
      c: "broń gazową i sygnałową",
    },
    correct: "b",
    explain: {
      a: "pozwolenie na broń palną do celów ochrony osobistej nie stanowi jednocześnie pozwolenia na broń sportową.",
      c: "pozwolenie na broń palną do celów ochrony osobistej nie stanowi jednocześnie pozwolenia na broń sygnałową.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ pozwolenie na broń palną do celów ochrony osobistej stanowi jednocześnie pozwolenie na broń gazową i alarmową.",
  },
  {
    id: 31,
    question:
      "Legitymację osoby dopuszczonej do posiadania broni wydaje: (art. 9 ust. 8 uobia)",
    answers: {
      a: "komendant wojewódzki Policji właściwy ze względu na miejsce stałego pobytu zainteresowanej osoby",
      b: "komendant wojewódzki Policji właściwy ze względu na miejsce czasowego pobytu zainteresowanej osoby",
      c: "komendant wojewódzki Policji właściwy ze względu na miejsce zameldowania zainteresowanej osoby",
    },
    correct: "a",
    explain: {
      b: "legitymację osoby dopuszczonej do posiadania broni wydawane są jedynie przez właściwego ze względu na miejsce stałego, a nie czasowego pobytu zainteresowanej osoby lub siedzibę zainteresowanego podmiotu komendanta wojewódzkiego Policji.",
      c: "legitymację osoby dopuszczonej do posiadania broni wydawane są jedynie przez właściwego ze względu na miejsce stałego pobytu, a nie adresu zameldowania zainteresowanej osoby lub siedzibę zainteresowanego podmiotu komendanta wojewódzkiego Policji.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ legitymację osoby dopuszczonej do posiadania broni wydawane są jedynie przez właściwego ze względu na miejsce stałego pobytu zainteresowanej osoby lub siedzibę zainteresowanego podmiotu komendanta wojewódzkiego Policji.",
  },
  {
    id: 32,
    question:
      "Świadectwo broni w myśl ustawy o broni i amunicji to: (art. 9 ust. 8 uobia)",
    answers: {
      a: "certyfikat producenta broni, umożliwiający jej bezpieczne użytkowanie",
      b: "potwierdzenie, ze jednostka broni nie była rejestrowana kryminalistycznie",
      c: "pozwolenie na broń na okaziciela",
    },
    correct: "c",
    explain: {
      b: "według tekstu ustawy świadectwo broni to inaczej pozwolenie na broń na okaziciela, a nie certyfikat producenta.",
      c: "odpowiedź jest nieprawidłowa, ponieważ świadectwo broni w tekscie ustawy jest nazwane pozwoleniem na broń na okaziciela.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ w tekście ustawy art. 8 ust. 8 pozwolenie na broń na okaziciela nazywane jest równierz świadectwem broni.",
  },
  {
    id: 33,
    question:
      "Właściwy organ Policji wydaje pozwolenie na broń jeżeli: (art. 10 ust. 1 uobia)",
    answers: {
      a: "wnioskodawca przedstawi ważną przyczynę posiadania broni",
      b: "wnioskodawca przedstawi zaświadczenie lekarskie o stanie zdrowia",
      c: "wnioskodawca posiada warunki do przechowywania broni",
    },
    correct: "a",
    explain: {
      b: "samo przedstawienie zaświadczenia o stanie zdrowia nie stanowi podstawy do wydania pozwolenia na broń.",
      c: "posiadanie odpowiednich warunków do przechowywania broni nie jest wystarczającym warunkiem otrzymania pozwolenia na broń.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ jednym z podstawowych warunków uzyskania pozolenia na broń, jest przedstawienie ważnej przyczyny posiadania broni.",
  },
  {
    id: 34,
    question:
      "Właściwy organ Policji wydaje pozwolenie na broń jeżeli: (art. 10 ust. 1 uobia)",
    answers: {
      a: "wnioskodawca nie stanowi zagrożenia dla samego siebie",
      b: "wnioskodawca nie stanowi zagrożenia dla porządku lub bezpieczeństwa publicznego",
      c: "odpowiedzi a i b są prawidłowe",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepełna, ponieważ wnioskodawca musi spełniać również inne warunki, takie jak brak zagrożenia dla porządku lub bezpieczeństwa publicznego.",
      b: "Odpowiedź 'b' jest niepełna, ponieważ wnioskodawca musi spełniać również warunek nie stanowić zagrożenia dla samego siebie.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zgodnie z art. 10 ust. 1 uobia, pozwolenie na broń jest wydawane, gdy wnioskodawca nie stanowi zagrożenia ani dla samego siebie, ani dla porządku lub bezpieczeństwa publicznego.",
  },
  {
    id: 35,
    question:
      "Za  ważną  przyczynę  posiadania  broni  do  celów  ochrony  osobistej  uważa  sie w szczególności: (art. 10. ust. 3 uobia)",
    answers: {
      a: "stałe, realne i ponadprzeciętne zagrożenie życia, zdrowia lub mienia",
      b: "zatrudnienie jako kwalifikowany pracownik ochrony fizycznej",
      c: "poczucie zagrożenia w związku z pełnioną slużbą",
    },
    correct: "a",
    explain: {
      b: "zgodnie z treścią ustawy zatrudnienie jako pracownik ochrony fizycznej nie jest ważną przyczyną posiadania broni do celów ochrony osobistej.",
      c: "poczucie zagrożenia w związku z pełnioną służbą, zgodnie z ustawą, nie jest ważną przyczyną do posaidania broni do celów ochrony osobistej.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ w ustawie jest wyraźnie określona ważna przyczyna posiadania broni do celów ochrony osobistej jako stałe, realne i ponadprzeciętne zagrożenie życia, zdrowia lub mienia.",
  },
  {
    id: 36,
    question:
      "Za ważną przyczynę posiadania broni do celów łowieckich uważa się w szczególności (art. 10. ust. 3 uobia)",
    answers: {
      a: "posiadanie licencji Polskiego Związku Łowieckiego",
      b: "posiadanie uprawnień do wykonywania polowania, ustalonych na podstawie odrębnych przepisów",
      c: "zaświadczenie o przynależności do koła łowieckiego",
    },
    correct: "b",
    explain: {
      a: "posiadanie licencji Polskiego Związku Łowieckiego nie jest wymagana jako podstawowy warunek ustawowy.",
      c: "przynależność do koła łowieckiego jest istotna w kontekście myślistwa, jednak nie jest wymagana jako podstawowy warunek ustawowy.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z art. 10 ust. 3 ustawy o broni i amunicji, tylko posiadanie uprawnień do wykonywania polowania, zgodnie z odrębnymi przepisami, jest uznawane za kluczową przyczynę w procesie wydawania pozwolenia na broń do celów łowieckich",
  },
  {
    id: 37,
    question:
      " Za ważną przyczynę posiadania broni do celów sportowych uważa się w szczególności (art. 10. ust. 3 uobia):",
    answers: {
      a: "udokumentowane uczestnictwo w strzeleckich zawodach sportowych",
      b: "posiadanie zezwolenia właściwego polskiego związku strzeleckiego na udział w strzeleckich zawodach sportowych",
      c: "udokumentowane członkostwo w stowarzyszeniu o charakterze strzeleckim, posiadanie kwalifikacji sportowych oraz licencji własciwego polskiego związku strzeleckiego",
    },
    correct: "c",
    explain: {
      a: "samo udokumentowane uczestnictwo w strzeleckich zawodach sportowych nie jest uznawane za ważną przyczynę posiadania broni do celów sportowych.",
      c: "posiadanie zezwolenia właściwego polskiego związku strzeleckiego na udział w strzeleckich zawodach sportowych również nie jest ważną przyczyną w rozumieniu ustawy.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ wszystkie warunki wymienione w tej odpowiedzi muszą zostać spełnione aby uzasadnić ważną przyczynę posiadania broni do celów sportowych.",
  },
  {
    id: 38,
    question:
      "Za ważną przyczynę posiadania broni do celów rekonstrukcji historycznych uważa sie w szczególności: (art. 10. ust. 3 uobia)",
    answers: {
      a: "udokumentowane członkostwo w stowarzyszeniu, którego statutowym celem jest organizowanie rekonstrukcji historycznych oraz zaświadczenie potwierdzające czynny udział w działalnosci statutowej",
      b: "udokumentowane członkostwo w stowarzyszeniu o charakterze paramilitarnym",
      c: "udokumentowany udział w przedsięwzięciach o charakterze historycznym",
    },
    correct: "a",
    explain: {
      b: "członkowstwo w stowarzyszeniu o charakterze paramilitarnym nie spełnia ustawowych warunków ważnej przyczyny posiadania tego typu pozwolenia na broń.",
      c: "udokumentowany udział w przedsięwzięciach o charakterze historycznym również nie jest ważną przyczyną posiadanie broni do celów rekonstrukcji historycznej",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ tylko ta odpowiedź zawiera wszystkie warunki wymagane ustawowo przy uzasadnieniu ważnej przyczyny posiadania broni do celów rekonstrukcji historycznych.",
  },
  {
    id: 39,
    question:
      "Za ważną przyczynę posiadania broni do celów kolekcjonerskich uważa sie w szczególności (art. 10. ust. 3 uobia):",
    answers: {
      a: "udokumentowane członkostwo w stowarzyszeniu, którego statutowym celem jest organizowanie rekonstrukcji historycznych",
      b: "udokumentowane członkostwo w stowarzyszeniu o charakterze kolekcjonerskim",
      c: "udokumentowany udział w ogólnokrajowych wystawach kolekcjonerów broni",
    },
    correct: "b",
    explain: {
      a: "członkostwo w stowarzyszeniu, którego statutowym celem jest organizowanie rekonstrukcji historycznych nie jest ważną przyczyną do posiadania broni do celów kolekcjonerskich",
      c: "udział w ogólnokrajowych wystawach kolekcjonerów broni nie jest ważną przyczyną do posiadania broni do celów kolekcjonerskich",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z ustawą udokumentowane członkostwo w stowarzyszeniu o charakterze kolekcjonerskim jest ważną przyczyną posiadania broni palnej do celów kolekcjonerskich ",
  },
  {
    id: 40,
    question:
      "Za ważną przyczynę posiadania broni do celów pamiątkowych uważa sie w szczególności (art. 10. ust. 3 uobia):",
    answers: {
      a: "udokumentowane nabycie broni w drodze spadku, darowizny lub wyróżnienia",
      b: "udokumentowany zakup broni historycznej",
      c: "odpowiedzi a. i b. sa nieprawidłowe",
    },
    correct: "a",
    explain: {
      b: "udokumentowany zakup broni historycznej nie jest ważną przyczyną posiadania broni do celów pamiątkowych ",
      c: "tylko odpowiedź b jest nieprawidłowa",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ udokumentowane nabycie broni w drodze spadku, darowizny lub wyróżnienia jest według ustawy ważną przyczyną do posiadania broni do celów pamiątkowych.",
  },
  {
    id: 41,
    question:
      "Za ważną przyczynę posiadania broni do celów szkoleniowych uważa się w szczególności: (art. 10. ust. 3 uobia)",
    answers: {
      a: "posiadanie licencji strzeleckiej związku strzeleckiego",
      b: "zaświadczenie o prowadzeniu strzelnicy",
      c: "udokumentowane zarejestrowanie działalności gospodarczej w zakresie szkoleń strzeleckich i posiadanie uprawnień do prowadzenia szkoleń strzeleckich",
    },
    correct: "c",
    explain: {
      a: "posiadanie licencji strzeleckiej związku strzeleckiego nie stanowi ważnej przyczyny posiadania broni do celów szkoleniowych",
      b: "zaświadczenie o prowadzeniu strzelnicy nie stanowi ważnej przyczyny posiadania broni do celów szkoleniowych.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ posiadanie uprawnień, określonych w odrębnych przepisach do prowadzenia szkoleń o charakterze strzeleckim oraz udokumentowane zarejestrowanie działalności gospodarczej w zakresie szkoleń strzeleckich jest ważną przyczyną posiadania broni do celów szkoleniowych",
  },
  {
    id: 42,
    question:
      "Na podstawie pozwolenia na broń wydanego w celu ochrony osobistej nie można posiadać: (art. 10 ust. 4 uobia)",
    answers: {
      a: "pistoletu bocznego zapłonu z lufą gwintowaną o kalibrze do 6 mm",
      b: "rewolweru centralnego zapłonu z lufą gwintowaną o kalibrze od 6 mm do 12 mm;",
      c: "miotacza gazu obezwładniającego",
    },
    correct: "a",
    explain: {
      b: "osoba z pozwoleniem na broń w celu ochrony osobistej, może posiadać rewolwer centralnego zapłonu z lufą gwintowaną o kalibrze od 6mm do 12mm.",
      c: "osoba z pozwoleniem na broń w celu ochrony osobistej, może posiadać miotacz gazu obezwładniającego",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ ustawa nie przewiduje dostępności tego rodzaju broni przy pozwoleniu na broń do celu ochrony osonistej.",
  },
  {
    id: 43,
    question:
      "Na podstawie pozwolenia na broń wydanego do celów łowieckich nie można posiadać: (art. 10 ust. 4 uobia)",
    answers: {
      a: "strzelby powtarzalnej o kalibrze wagomiarowym 12",
      b: "pistoletu bocznego zapłonu z lufą gwintowaną o kalibrze do 6 mm",
      c: "karabinu centralnego zapłonu z lufą gwintowaną o kalibrze do 12 mm",
    },
    correct: "b",
    explain: {
      a: "Strzelby powtarzalne o kalibrze wagomiarowym 12 są dozwolone do celów łowieckich",
      c: "Karabiny centralnego zapłonu z lufą gwintowaną o kalibrze do 12 mm są dozwolone na cele łowieckie, ponieważ karabiny centralnego zapłonu są jednymi z podstawowych rodzajów broni używanych w polowaniach.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ pistolet bocznego zapłonu z lufą gwintowaną o kalibrze do 6mm nie jest dozwolony na podstawie pozwolenia łowieckiego.",
  },
  {
    id: 44,
    question:
      "Na podstawie pozwolenia na broń wydanego w celu sportowym nie można posiadać: (art. 10 ust. 4 uobia)",
    answers: {
      a: "karabinu centralnego zaplonu z lufa gwintowana o kalibrze do 12 mm",
      b: "rewolweru przystosowanego do strzelania wylacznie przy pomocy prochu czarnego (dymnego)",
      c: "pistoletu sygnałowego",
    },
    correct: "c",
    explain: {
      a: "Karabin centralnego zapłonu z lufą gwintowaną o kalibrze do 12 mm jest dozwolony do celów sportowych.",
      b: "Rewolwer przystosowany do strzelania wyłącznie przy pomocy prochu czarnego (dymnego) może być używany w strzelectwie sportowym, szczególnie w konkurencjach historycznych i rekonstrukcyjnych, ale jest klasyfikowany jako broń rozdzielnego ładowania, co nie wyklucza go z celów sportowych. Odpowiedź b także nie jest poprawna",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ Pistolet sygnałowy nie jest bronią używaną do celów sportowych. Jego głównym przeznaczeniem jest sygnalizacja, a nie strzelanie sportowe, dlatego nie można posiadać pistoletu sygnałowego na podstawie pozwolenia sportowego.",
  },
  {
    id: 45,
    question:
      "Na podstawie pozwolenia na broń wydanego w celu szkoleniowym nie można posiadać: (art. 10 ust. 4 uobia)",
    answers: {
      a: "karabinu centralnego zapłonu z lufą gwintowaną o kalibrze do 12 mm",
      b: "rewolweru przystosowanego do strzelania wyłącznie przy pomocy prochu czarnego (dymnego)",
      c: "broni alarmowej albo innej broni palnej, konstrukcyjnie przeznaczonej do strzelania wyłącznie amunicją ślepą, w tym samoczynnej",
    },
    correct: "c",
    explain: {
      a: "Karabin centralnego zapłonu z lufą gwintowaną o kalibrze do 12 mm jest dopuszczony do użytku w celach szkoleniowych, ponieważ tego typu broń jest standardowo używana w różnego rodzaju szkoleniach strzeleckich. Dlatego odpowiedź a nie jest poprawna",
      b: "Rewolwer przystosowany do strzelania wyłącznie przy pomocy prochu czarnego (dymnego) może być wykorzystywany w celach szkoleniowych, zwłaszcza w szkoleniach historycznych lub związanych z bronią czarnoprochową. Odpowiedź b również nie jest poprawna",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ Broń alarmowa albo inna broń palna, konstrukcyjnie przeznaczona do strzelania wyłącznie amunicją ślepą, w tym samoczynna, nie może być używana w celach szkoleniowych, ponieważ tego rodzaju broń nie służy do nauki strzelania ostrą amunicją, ale jest przeznaczona wyłącznie do sygnalizacji lub symulacji. Broń samoczynna, zwłaszcza strzelająca amunicją ślepą, nie spełnia funkcji szkoleniowych",
  },
  {
    id: 46,
    question:
      "Na podstawie pozwolenia na broń wydanego w celu kolekcjonerskim lub pamiątkowym można posiadać: (art. 10 ust. 4 uobia)",
    answers: {
      a: "pistolet sygnalowy",
      b: "broń alarmowa albo inna broń palna, konstrukcyjnie przeznaczona do strzelania wyłącznie amunicją slepą, w tym samoczynna",
      c: "odpowiedzi a. i b. sa prawidlowe",
    },
    correct: "a",
    explain: {
      b: "broń alarmowa albo inna broń palna, konstrukcyjnie przeznaczona do strzelania wyłącznie amunicją slepą, w tym samoczynna nie znajduje się w wykazie broni dostępnej dla pozwolenia na broń do celów kolekcjonerskim lub pamiątkowym",
      c: "tylko odpowiedź a jest prawidłowa",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ pistolet sygnałowy jest ujęty w tekscie ustawy przy pozwoleniu na broń w celu kolekcjonerskim lub pamiątkowym.",
  },
  {
    id: 47,
    question:
      "Bronią szczególnie niebezpieczną, w rozumieniu ustawy o broni i amunicji, nie jest: (art. 10 ust. 5 uobia)",
    answers: {
      a: "broń palna z wymienną lufa",
      b: "samoczynną broń palną zdolną do rażenia celów na odległość",
      c: "broń palna wytworzona lub przerobiona w sposób pozwalający na zatajenie jej przeznaczenia, a także broń imitujacą inne przedmioty",
    },
    correct: "a",
    explain: {
      b: "Samoczynna broń palna zdolna do rażenia celów na odległość jest klasyfikowana jako broń szczególnie niebezpieczna. Broń samoczynna (czyli automatyczna), zdolna do strzelania ciągłego, stanowi poważne zagrożenie, dlatego jest ograniczana prawnie. Odpowiedź b jest nieprawidłowa, ponieważ taka broń jest uznawana za szczególnie niebezpieczną.",
      c: "Broń palna wytworzona lub przerobiona w sposób pozwalający na zatajenie jej przeznaczenia, a także broń imitująca inne przedmioty również jest uznawana za broń szczególnie niebezpieczną. Ten typ broni, który może przypominać np. przedmioty codziennego użytku, stwarza poważne zagrożenie, ponieważ może być ukryta lub używana w sposób trudny do przewidzenia. Odpowiedź c jest również nieprawidłowa, ponieważ taka broń jest klasyfikowana jako szczególnie niebezpieczna.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ broń palna z wymienną lufą nie jest uznawana za broń szczególnie niebezpieczną w rozumieniu ustawy. Możliwość wymiany lufy nie czyni broni bardziej niebezpieczną w sensie prawnym, ponieważ ten typ broni jest stosowany w różnych legalnych zastosowaniach, takich jak sport czy polowanie. Odpowiedź a jest poprawna – taka broń nie jest uznawana za szczególnie niebezpieczną.",
  },
  {
    id: 48,
    question:
      "Bronią szczególnie niebezpieczną, w rozumieniu ustawy o broni i amunicji, nie jest: (art. 10 ust. 5 uobia)",
    answers: {
      a: "broń palna wyposażona w tłumik huku lub przystosowana do strzelania z użyciem tłumika huku;",
      b: "strzelba gladkolufowa posiadająca więcej niż jedną lufę",
      c: "broń palna, której nie można wykryć przy pomocy urządzeń przeznaczonych do kontroli osób i bagażu",
    },
    correct: "b",
    explain: {
      a: "Broń palna wyposażona w tłumik huku lub przystosowana do strzelania z użyciem tłumika huku jest uznawana za szczególnie niebezpieczną, ponieważ tłumik skutecznie zmniejsza hałas wydawany przy strzale, co utrudnia jej wykrycie i zwiększa potencjalne zagrożenie. Odpowiedź a jest nieprawidłowa, ponieważ taka broń jest klasyfikowana jako szczególnie niebezpieczna.",
      c: "Broń palna, której nie można wykryć przy pomocy urządzeń przeznaczonych do kontroli osób i bagażu, jest uznawana za szczególnie niebezpieczną. Tego rodzaju broń, wykonana z materiałów niemetalicznych, które mogą umykać detekcji, stanowi poważne zagrożenie bezpieczeństwa publicznego. Odpowiedź c jest nieprawidłowa, ponieważ taka broń jest klasyfikowana jako szczególnie niebezpieczna",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ strzelba gładkolufowa posiadająca więcej niż jedną lufę nie jest uznawana za broń szczególnie niebezpieczną w rozumieniu UoBiA. Strzelby z dwiema lufami (np. strzelby dwulufowe) są powszechnie używane w łowiectwie i sportach strzeleckich, i choć są efektywne, nie stanowią nadzwyczajnego zagrożenia. Odpowiedź b jest poprawna – taka broń nie jest klasyfikowana jako szczególnie niebezpieczna.",
  },
  {
    id: 49,
    question:
      "Amunicją szczególnie niebezpieczną, w rozumieniu ustawy o broni i amunicji jest: (art. 10 ust. 6 uobia)",
    answers: {
      a: "amunicja  z  pociskami  pełnopłaszczowymi  zawierającymi  rdzeń  wykonany z materiału twardszego niż stop ołowiu",
      b: "amunicja z pociskami wypełnionymi materiałami wybuchowymi, zapalającymi albo innymi substancjami, których działanie zagraża życiu lub zdrowiu oraz pociski do takiej amunicji",
      c: "odpowiedz a. i b. sa prawidłowe",
    },
    correct: "c",
    explain: {
      a: "Amunicja z pociskami pełnopłaszczowymi zawierającymi rdzeń wykonany z materiału twardszego niż stop ołowiu jest uznawana za szczególnie niebezpieczną. Tego rodzaju amunicja, często z rdzeniem ze stali lub innych twardych materiałów, ma zwiększoną zdolność penetracji i może łatwiej przebijać osłony, co czyni ją wyjątkowo niebezpieczną. Odpowiedź a jest prawidłowa.",
      b: "Amunicja z pociskami wypełnionymi materiałami wybuchowymi, zapalającymi albo innymi substancjami, których działanie zagraża życiu lub zdrowiu, również jest klasyfikowana jako amunicja szczególnie niebezpieczna. Tego rodzaju amunicja jest zaprojektowana, aby powodować dodatkowe obrażenia lub zniszczenia poprzez eksplozję, zapalenie lub działanie substancji chemicznych. Odpowiedź b jest również prawidłowa.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zarówno amunicja z pociskami pełnopłaszczowymi z twardym rdzeniem, jak i amunicja wypełniona materiałami wybuchowymi, zapalającymi lub innymi niebezpiecznymi substancjami, jest uznawana za amunicję szczególnie niebezpieczną. Tego rodzaju amunicja zwiększa ryzyko dla życia i zdrowia ze względu na swoje specyficzne właściwości penetracyjne i destrukcyjne. Tak więć odpowiedzi a i b są prawidłowe.",
  },
  {
    id: 50,
    question:
      "Posiadanie amunicji wytworzonej niefabrycznie, w tym takiej, do której wytworzenia wykorzystywane sa fabrycznie nowe elementy amunicji, na własny użytek jest: (art. 10 ust. 6 uobia)",
    answers: {
      a: "zabronione",
      b: "dozwolone przez osoby posiadające pozwolenie na broń kolekcjonerską",
      c: "dozwolone przez osoby posiadające pozwolenie na broń szkoleniową",
    },
    correct: "b",
    explain: {
      a: "zgodnie z art. 10 ust. 6 UoBiA, posiadanie amunicji wytworzonej niefabrycznie, w tym takiej, do której wytworzenia wykorzystywane są fabrycznie nowe elementy amunicji, jest dozwolone, ale wyłącznie dla osób posiadających odpowiednie pozwolenie na broń sportową lub kolekcjonerską.",
      c: "posiadanie tego typu amunicji nie jest dozwolone przy posiadaniu pozolenia na broń do celów szkoleniowych",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z art. 10 ust. 6 UoBiA, posiadanie amunicji wytworzonej niefabrycznie, w tym takiej, do której wytworzenia wykorzystywane są fabrycznie nowe elementy amunicji, jest dozwolone, ale wyłącznie dla osób posiadających odpowiednie pozwolenie na broń sportową lub kolekcjonerską.",
  },
  {
    id: 51,
    question:
      "Właściwy organ Policji może w pozwoleniu na broń ograniczyć lub wykluczyć możliwość noszenia broni: (art. 10 ust. 7 uobia)",
    answers: {
      a: "co potwierdza sie w legitymacji posiadacza broni",
      b: "tylko w przypadku broni posiadanej na pozwolenie do celów kolekcjonerskich, co potwierdza się w legitymacji posiadacza broni",
      c: "możliwości noszenia broni nie można ograniczyc lub wykluczyć",
    },
    correct: "a",
    explain: {
      b: "Art. 10 ust. 7 nie ogranicza się jedynie do broni kolekcjonerskiej, więc możliwość wprowadzenia ograniczeń dotyczy każdej broni wydanej na pozwolenie.",
      c: "Ustawa jasno precyzuje, że właściwy organ Policji może ograniczyć lub wykluczyć możliwość noszenia broni. Takie ograniczenia mogą być stosowane, np. z uwagi na charakter pozwolenia, okoliczności posiadania broni czy bezpieczeństwo publiczne.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z art. 10 ust. 7 ustawy o broni i amunicji (uobia), właściwy organ Policji może ograniczyć lub wykluczyć możliwość noszenia broni, co potwierdza się w legitymacji posiadacza broni.",
  },
  {
    id: 52,
    question:
      "Noszenie broni bez zgody właściwego organu Policji jest zabronione w przypadku broni posiadanej na podstawie pozwolenia do celów: (art. 10 ust. 8 uobia)",
    answers: {
      a: "rekonstrukcji historycznych lub kolekcjonerskich",
      b: "kolekcjonerskich lub pamiątkowych",
      c: "pamiątkowych lub szkoleniowych",
    },
    correct: "b",
    explain: {
      a: "Ustawa nie wspomina o rekonstrukcjach historycznych w kontekście zakazu noszenia broni bez zgody Policji. Chociaż broń może być używana do rekonstrukcji historycznych, to pozwolenia na te cele nie są wymienione w art. 10 ust. 8 uobia jako wymagające dodatkowej zgody na noszenie broni.",
      c: "Ustawa nie zabrania noszenia broni posiadanej na podstawie pozwolenia do celów szkoleniowych, o ile właściciel spełnia wszystkie inne warunki. Zakaz dotyczy wyłącznie broni do celów kolekcjonerskich i pamiątkowych, a cele szkoleniowe nie są wymienione w art. 10 ust. 8 uobia.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ art. 10 ust. 8 uobia wyraźnie wskazuje, że broń posiadana na podstawie pozwolenia do celów kolekcjonerskich lub pamiątkowych nie może być noszona bez zgody właściwego organu Policji. Oznacza to, że osoby posiadające broń na te cele muszą uzyskać specjalne zezwolenie, jeśli chcą nosić broń publicznie.",
  },
  {
    id: 53,
    question:
      "Noszenie broni, w rozumieniu ustawy o broni i amunicji to: (art. 10 ust. 9 uobia)",
    answers: {
      a: "każdy sposób przemieszczania załadowanej broni przez osobę posiadającą broń",
      b: "każdy sposób przemieszczania przeładowanej broni przez osobę posiadającą broń",
      c: "każdy sposób przemieszczania broni przez osobę posiadającą broń",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ ustawa nie odnosi się do pojęcia 'przeładowanej' broni. Liczy się tylko fakt, że broń jest załadowana.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ noszenie broni w rozumieniu ustawy dotyczy tylko załadowanej broni, a nie każdego rodzaju przemieszczania broni.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z ustawą o broni i amunicji, noszenie broni oznacza każdy sposób przemieszczania załadowanej broni przez osobę posiadającą broń.",
  },
  {
    id: 54,
    question: "Europejską kartę broni palnej wydaje: (art. 10a ust. 1 uobia)",
    answers: {
      a: "komendant wojewódzki Policji właściwy ze względu na miejsce zameldowania osoby zainteresowanej",
      b: "komendant wojewódzki Policji właściwy ze względu na miejsce czasowego pobytu osoby zainteresowanej",
      c: "komendant wojewódzki Policji właściwy ze względu na miejsce stałego pobytu osoby zainteresowanej",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ wydanie Europejskiej karty broni palnej zależy od miejsca stałego pobytu, a nie zameldowania.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ karta nie jest wydawana na podstawie miejsca czasowego pobytu, lecz stałego pobytu.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zgodnie z art. 10a ust. 1 ustawy o broni i amunicji, Europejską kartę broni palnej wydaje komendant wojewódzki Policji właściwy ze względu na miejsce stałego pobytu osoby zainteresowanej.",
  },
  {
    id: 55,
    question:
      "Właściwy organ Policji wydaje Europejską kartę broni palnej (art. 10a ust. 1 uobia):",
    answers: {
      a: "na wniosek osoby posiadającej broń palną zgodnie z wymogami prawa polskiego",
      b: "na wniosek organizacji sportowej, osobie wskazanej przez ten podmiot oraz posiadającej dopuszczenie do posiadania broni",
      c: "odpowiedzi a. i b. są prawidłowe",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest poprawna, ale niepełna. Właściwy organ Policji wydaje Europejską kartę broni palnej również na wniosek organizacji sportowej.",
      b: "Odpowiedź 'b' jest poprawna, ale niepełna. Europejska karta broni palnej może być wydana także na wniosek osoby prywatnej posiadającej broń palną zgodnie z wymogami prawa polskiego.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zarówno wniosek osoby prywatnej, jak i organizacji sportowej może być podstawą do wydania Europejskiej karty broni palnej.",
  },
  {
    id: 56,
    question:
      "Europejską kartę broni palnej wydaje się na okres: (art. 10a ust. 2 uobia)",
    answers: {
      a: "do 5 lat",
      b: "do 3 lat",
      c: "do 7 lat",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ Europejska karta broni palnej może być wydana na dłuższy okres niż 3 lata.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ Europejska karta broni palnej może być wydana maksymalnie na 5 lat, a nie 7 lat.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z art. 10a ust. 2 uobia, Europejską kartę broni palnej wydaje się na okres do 5 lat.",
  },
  {
    id: 57,
    question:
      "Po upływie okresu ważności Europejskiej karty broni palnej: (art. 10a ust. 3 uobia)",
    answers: {
      a: "należy ją zwrócić",
      b: "jej ważność może być przedłużona na kolejny okres",
      c: "należy ją wymienić",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ po upływie okresu ważności karty nie ma konieczności jej zwracania, ale można ją przedłużyć.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ karta nie musi być wymieniana, a jej ważność może zostać przedłużona.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z art. 10a ust. 3 uobia, po upływie okresu ważności Europejskiej karty broni palnej jej ważność może być przedłużona na kolejny okres.",
  },
  {
    id: 58,
    question:
      "Europejska karta broni palnej traci ważność i podlega zwrotowi: (art. 10a ust. 4 uobia)",
    answers: {
      a: "w przypadku cofnięcia pozwolenia na broń palną lub cofnięcia dopuszczenia do posiadania tego rodzaju broni",
      b: "w przypadku naruszenia obowiązku zawiadomienia właściwego organu Policji o zmianie miejsca stałego pobytu",
      c: "w przypadku naruszenia zakazu użyczania broni osobie nieupoważnionej",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ naruszenie obowiązku zawiadomienia Policji o zmianie miejsca pobytu nie powoduje utraty ważności Europejskiej karty broni palnej.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ naruszenie zakazu użyczania broni osobie nieupoważnionej nie jest bezpośrednią przyczyną utraty ważności karty.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z art. 10a ust. 4 uobia, Europejska karta broni palnej traci ważność i podlega zwrotowi w przypadku cofnięcia pozwolenia na broń palną lub cofnięcia dopuszczenia do posiadania tego rodzaju broni.",
  },
  {
    id: 59,
    question:
      "Wpisów do Europejskiej karty broni palnej dokonuje: (art. 10 ust. 7 uobia)",
    answers: {
      a: "komendant wojewódzki Policji właściwy ze względu na miejsce zameldowania osoby posiadającej Europejską kartę broni palnej",
      b: "komendant wojewódzki Policji właściwy ze względu na miejsce czasowego pobytu osoby posiadającej Europejską kartę broni palnej",
      c: "komendant wojewódzki Policji właściwy ze względu na miejsce stałego pobytu osoby posiadającej Europejską kartę broni palnej",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ wpisów do karty dokonuje się na podstawie miejsca stałego pobytu, a nie zameldowania.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ wpisów nie dokonuje się na podstawie miejsca czasowego pobytu.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zgodnie z art. 10 ust. 7 uobia, wpisów do Europejskiej karty broni palnej dokonuje komendant wojewódzki Policji właściwy ze względu na miejsce stałego pobytu osoby posiadającej tę kartę.",
  },
  {
    id: 60,
    question: "Pozwolenia na broń nie wymaga się w przypadku: (art. 11 uobia)",
    answers: {
      a: "posiadania przedmiotów przeznaczonych do obezwładniania osób za pomocą energii elektrycznej o średniej wartości prądu w obwodzie przekraczającej 10 mA",
      b: "gromadzenia broni w zbiorach muzealnych na podstawie odrębnych przepisów",
      c: "posiadania broni palnej rozdzielnego ładowania, wytworzonej po roku 1885",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ posiadanie urządzeń do obezwładniania osób za pomocą energii elektrycznej może wymagać pozwolenia, szczególnie jeśli prąd w obwodzie przekracza 10 mA.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ pozwolenie na broń jest wymagane dla broni palnej rozdzielnego ładowania, wytworzonej po roku 1885.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ gromadzenie broni w zbiorach muzealnych, na podstawie odrębnych przepisów, nie wymaga pozwolenia zgodnie z art. 11 uobia.",
  },
  {
    id: 61,
    question: "Pozwolenia na broń wymaga się w przypadku: (art. 11 uobia)",
    answers: {
      a: "używania broni w celach sportowych, szkoleniowych lub rekreacyjnych na strzelnicy działającej na podstawie zezwolenia właściwego organu",
      b: "używania broni palnej sygnałowej i alarmowej do celów wzywania pomocy, ratowniczych, poszukiwawczych oraz przez osoby uprawnione do sygnalizacji zawodnikom rozpoczęcia konkurencji sportowej w trakcie zawodów sportowych, jeżeli wymaga ona takiej sygnalizacji",
      c: "posiadania broni palnej gazowej",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ używanie broni na strzelnicy działającej legalnie nie wymaga pozwolenia na broń, jeśli spełnione są odpowiednie warunki.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ używanie broni palnej sygnałowej i alarmowej w wymienionych przypadkach nie wymaga pozwolenia na broń.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ posiadanie broni palnej gazowej wymaga pozwolenia zgodnie z art. 11 uobia.",
  },
  {
    id: 62,
    question: "Pozwolenia na broń nie wymaga się w przypadku: (art. 11 uobia)",
    answers: {
      a: "posiadania broni palnej pozbawionej cech użytkowych",
      b: "posiadania broni alarmowej albo innej broni palnej, konstrukcyjnie przeznaczonej do strzelania wyłącznie amunicją ślepą, w tym samoczynnej",
      c: "posiadania broni cięciwowej w postaci kuszy",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ posiadanie niektórych rodzajów broni alarmowej i samoczynnej może wymagać pozwolenia.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ posiadanie kuszy, będącej bronią cięciwową, może wymagać pozwolenia.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ broń palna pozbawiona cech użytkowych nie wymaga pozwolenia zgodnie z art. 11 uobia.",
  },
  {
    id: 63,
    question: "Pozwolenia na broń wymaga się w przypadku: (art. 11 uobia)",
    answers: {
      a: "posiadania ręcznych miotaczy gazu obezwładniającego",
      b: "posiadania broni pneumatycznej",
      c: "posiadania przedmiotów przeznaczonych do obezwładniania osób za pomocą energii elektrycznej o średniej wartości prądu w obwodzie przekraczającej 10 mA",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ posiadanie ręcznych miotaczy gazu obezwładniającego nie wymaga pozwolenia na broń.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ posiadanie broni pneumatycznej w Polsce nie wymaga pozwolenia na broń.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ posiadanie przedmiotów przeznaczonych do obezwładniania osób za pomocą energii elektrycznej o średniej wartości prądu w obwodzie przekraczającej 10 mA wymaga pozwolenia zgodnie z art. 11 uobia.",
  },
  {
    id: 64,
    question: "Pozwolenia na broń nie wymaga się w przypadku: (art. 11 uobia)",
    answers: {
      a: "posiadania broni palnej rozdzielnego ładowania, wytworzonej przed rokiem 1885 oraz replik tej broni",
      b: "posiadania pistoletów sygnałowych",
      c: "posiadania kastetu",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ posiadanie pistoletów sygnałowych wymaga pozwolenia na broń.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ kastety są zakazane i wymagają odpowiednich zezwoleń.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ posiadanie broni palnej rozdzielnego ładowania, wytworzonej przed rokiem 1885 oraz jej replik, nie wymaga pozwolenia na broń zgodnie z art. 11 uobia.",
  },
  {
    id: 65,
    question: "Pozwolenie na broń jest wydawane: (art. 12 uobia)",
    answers: {
      a: "w drodze postanowienia",
      b: "w drodze decyzji administracyjnej",
      c: "w drodze zaświadczenia",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ pozwolenie na broń nie jest wydawane w drodze postanowienia.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ pozwolenie na broń nie jest wydawane w formie zaświadczenia.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z art. 12 uobia, pozwolenie na broń jest wydawane w drodze decyzji administracyjnej.",
  },
  {
    id: 66,
    question:
      "W decyzji administracyjnej, przyznającej pozwolenie na broń, określa się: (art. 12 uobia)",
    answers: {
      a: "wyłącznie cel, w jakim zostało wydane",
      b: "wyłącznie rodzaj i liczbę egzemplarzy broni",
      c: "cel, w jakim zostało wydane oraz rodzaj i liczbę egzemplarzy broni",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ w decyzji administracyjnej określa się nie tylko cel wydania pozwolenia, ale także rodzaj i liczbę egzemplarzy broni.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ decyzja administracyjna musi także określać cel, w jakim pozwolenie zostało wydane.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zgodnie z art. 12 uobia, w decyzji administracyjnej, przyznającej pozwolenie na broń, określa się zarówno cel, w jakim zostało wydane, jak i rodzaj oraz liczbę egzemplarzy broni.",
  },
  {
    id: 67,
    question:
      "Zaświadczenie uprawniające do nabycia broni: (art. 12 ust. 2 uobia)",
    answers: {
      a: "wydawane jest na wniosek osoby posiadającej pozwolenie na broń i uprawnia do nabycia broni i amunicji do tej broni",
      b: "wydawane jest z urzędu i uprawnia do nabycia broni i amunicji do tej broni",
      c: "wydawane jest na wniosek osoby posiadającej pozwolenie na broń i uprawnia do nabycia wyłącznie broni",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ zaświadczenie nie jest wydawane z urzędu, lecz na wniosek osoby posiadającej pozwolenie na broń.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ zaświadczenie uprawnia do nabycia zarówno broni, jak i amunicji do tej broni, a nie tylko broni.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z art. 12 ust. 2 uobia, zaświadczenie uprawniające do nabycia broni wydawane jest na wniosek osoby posiadającej pozwolenie na broń i uprawnia do nabycia zarówno broni, jak i amunicji do tej broni.",
  },
  {
    id: 68,
    question: "Zaświadczenie uprawniające do nabycia broni:",
    answers: {
      a: "uprawnia do nabycia dowolnej ilości broni",
      b: "uprawnia do nabycia broni w ilości określonej w zaświadczeniu",
      c: "uprawnia do nabycia wyłącznie jednej sztuki broni",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ zaświadczenie nie uprawnia do nabycia dowolnej ilości broni, a jedynie do ilości określonej w zaświadczeniu.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ zaświadczenie może uprawniać do nabycia więcej niż jednej sztuki broni, zależnie od tego, co jest w nim określone.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zaświadczenie uprawniające do nabycia broni uprawnia do nabycia broni w ilości określonej w zaświadczeniu.",
  },
  {
    id: 69,
    question: "Zaświadczenie uprawniające do nabycia broni jest:",
    answers: {
      a: "ważne 30 dni",
      b: "ważne 3 miesiące",
      c: "bezterminowe",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ zaświadczenie nie traci ważności po 30 dniach.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ zaświadczenie nie ma ograniczenia czasowego do 3 miesięcy.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zaświadczenie uprawniające do nabycia broni jest bezterminowe zgodnie z przepisami uobia.",
  },
  {
    id: 70,
    question:
      "Nabywając broń palną, na której posiadanie wymagane jest pozwolenie, przy użyciu środków porozumiewania się na odległość, przed wydaniem broni nabywca mający miejsce stałego pobytu na terytorium Rzeczypospolitej Polskiej, dostarcza zbywcy mającemu miejsce stałego pobytu na terytorium Rzeczypospolitej Polskiej: (art. 12a ust. 2 uobia)",
    answers: {
      a: "zaświadczenie uprawniające do nabycia broni",
      b: "uprzednią zgodę przewozową",
      c: "zgodę przewozową",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ uprzednia zgoda przewozowa jest wymagana przy zakupie broni z zagranicy, a nie w przypadku zakupu krajowego.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ zgoda przewozowa dotyczy transportu broni przez granicę, a nie zakupu broni w kraju.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z art. 12a ust. 2 uobia, nabywca broni palnej, przy zakupie na terenie Polski, musi dostarczyć zaświadczenie uprawniające do nabycia broni.",
  },
  {
    id: 71,
    question:
      "Nabywając broń palną, na której posiadanie wymagane jest pozwolenie, przy użyciu środków porozumiewania się na odległość, przed wydaniem broni nabywca mający miejsce stałego pobytu na terytorium innego niż Rzeczpospolita Polska państwa członkowskiego Unii Europejskiej, dostarcza zbywcy mającemu miejsce stałego pobytu na terytorium Rzeczypospolitej Polskiej: (art. 12a ust. 2 uobia)",
    answers: {
      a: "zgodę przewozową",
      b: "uprzednią zgodę przewozową",
      c: "zaświadczenie uprawniające do nabycia broni",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ nie wystarczy zgoda przewozowa, konieczna jest uprzednia zgoda przewozowa.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ nabywca z innego państwa członkowskiego UE musi dostarczyć uprzednią zgodę przewozową, a nie zaświadczenie.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z art. 12a ust. 2 uobia, nabywca z innego państwa członkowskiego UE musi dostarczyć uprzednią zgodę przewozową przed wydaniem broni.",
  },
  {
    id: 72,
    question:
      "Nabywca broni obowiązany jest ją zarejestrować: (art. 13 ust. 1 uobia)",
    answers: {
      a: "w ciągu 7 dni od dnia nabycia",
      b: "w ciągu 10 dni od dnia nabycia",
      c: "w ciągu 5 dni od dnia nabycia",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ zgodnie z przepisami, termin na rejestrację broni to 5 dni, a nie 7 dni.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ termin 10 dni jest za długi, a obowiązujący termin to 5 dni.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zgodnie z art. 13 ust. 1 uobia, nabywca broni musi zarejestrować ją w ciągu 5 dni od dnia nabycia.",
  },
  {
    id: 73,
    question:
      "Rejestracji broni dokonuje się na podstawie: (art. 13 ust. 2 uobia)",
    answers: {
      a: "dowodu nabycia broni",
      b: "instrukcji obsługi broni",
      c: "karty gwarancyjnej broni",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ instrukcja obsługi broni nie jest dokumentem wymaganym do rejestracji broni.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ karta gwarancyjna nie jest podstawą do rejestracji broni.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z art. 13 ust. 2 uobia, rejestracji broni dokonuje się na podstawie dowodu nabycia broni.",
  },
  {
    id: 74,
    question:
      "Rejestracji broni palnej pozbawionej cech użytkowych dokonuje się na podstawie: (art. 13 ust. 2 uobia)",
    answers: {
      a: "dowodu nabycia broni oraz dodatkowo po przedstawieniu potwierdzenia pozbawienia broni palnej cech użytkowych",
      b: "wyłącznie dowodu nabycia broni",
      c: "wyłącznie po przedstawieniu potwierdzenia pozbawienia broni palnej cech użytkowych",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ w przypadku broni pozbawionej cech użytkowych wymagane jest dodatkowe potwierdzenie pozbawienia broni cech użytkowych.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ rejestracja wymaga również dowodu nabycia broni, a nie tylko potwierdzenia pozbawienia cech użytkowych.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z art. 13 ust. 2 uobia, rejestracji broni palnej pozbawionej cech użytkowych dokonuje się na podstawie dowodu nabycia broni oraz potwierdzenia pozbawienia jej cech użytkowych.",
  },
  {
    id: 75,
    question: "Rejestracji broni palnej dokonuje: (art. 13 ust. 3 uobia)",
    answers: {
      a: "komendant wojewódzki Policji właściwy ze względu na miejsce czasowego pobytu osoby posiadającej pozwolenie na broń",
      b: "komendant wojewódzki Policji właściwy ze względu na miejsce stałego pobytu osoby posiadającej pozwolenie na broń",
      c: "komendant wojewódzki Policji właściwy ze względu na miejsce zameldowania osoby posiadającej pozwolenie na broń",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ rejestracji broni dokonuje komendant wojewódzki Policji właściwy ze względu na miejsce stałego, a nie czasowego pobytu.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ rejestracji broni dokonuje komendant wojewódzki Policji właściwy ze względu na miejsce stałego pobytu, a nie zameldowania.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z art. 13 ust. 3 uobia, rejestracji broni dokonuje komendant wojewódzki Policji właściwy ze względu na miejsce stałego pobytu osoby posiadającej pozwolenie na broń.",
  },
  {
    id: 76,
    question:
      "Rejestracji broni palnej pozbawionej cech użytkowych dokonuje: (art. 13 ust. 3 uobia)",
    answers: {
      a: "komendant wojewódzki Policji właściwy ze względu na miejsce czasowego pobytu osoby posiadającej broń palną pozbawioną cech użytkowych",
      b: "komendant wojewódzki Policji właściwy ze względu na miejsce zameldowania osoby posiadającej broń palną pozbawioną cech użytkowych",
      c: "komendant wojewódzki Policji właściwy ze względu na miejsce stałego pobytu osoby posiadającej broń palną pozbawioną cech użytkowych",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ rejestracji broni palnej pozbawionej cech użytkowych dokonuje się na podstawie miejsca stałego pobytu, a nie czasowego.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ rejestracji dokonuje komendant Policji właściwy ze względu na miejsce stałego pobytu, a nie zameldowania.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zgodnie z art. 13 ust. 3 uobia, rejestracji broni palnej pozbawionej cech użytkowych dokonuje komendant wojewódzki Policji właściwy ze względu na miejsce stałego pobytu osoby posiadającej broń.",
  },
  {
    id: 77,
    question:
      "Rejestracji broni pneumatycznej dokonuje: (art. 13 ust. 3 uobia)",
    answers: {
      a: "komendant wojewódzki Policji właściwy ze względu na miejsce stałego pobytu osoby posiadającej broń pneumatyczną",
      b: "komendant powiatowy Policji właściwy ze względu na miejsce stałego pobytu osoby posiadającej broń pneumatyczną",
      c: "komendant komisariatu Policji właściwy ze względu na miejsce stałego pobytu osoby posiadającej broń pneumatyczną",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ rejestracji broni pneumatycznej dokonuje komendant powiatowy Policji, a nie komendant wojewódzki.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ rejestracji broni pneumatycznej dokonuje komendant powiatowy Policji, a nie komendant komisariatu.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z art. 13 ust. 3 uobia, rejestracji broni pneumatycznej dokonuje komendant powiatowy Policji właściwy ze względu na miejsce stałego pobytu osoby posiadającej broń.",
  },
  {
    id: 78,
    question:
      "Rejestracji broni cięciwowej w postaci kuszy dokonuje: (art. 13 ust. 3 uobia)",
    answers: {
      a: "komendant powiatowy Policji właściwy ze względu na miejsce stałego pobytu osoby posiadającej pozwolenie na broń",
      b: "komendant powiatowy Policji właściwy ze względu na miejsce czasowego pobytu osoby posiadającej pozwolenie na broń",
      c: "komendant powiatowy Policji właściwy ze względu na miejsce zameldowania osoby posiadającej pozwolenie na broń",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ rejestracja odbywa się na podstawie miejsca stałego pobytu, a nie czasowego.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ rejestracja broni cięciwowej w postaci kuszy odbywa się na podstawie miejsca stałego pobytu, a nie miejsca zameldowania.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z art. 13 ust. 3 uobia, rejestracji broni cięciwowej w postaci kuszy dokonuje komendant powiatowy Policji właściwy ze względu na miejsce stałego pobytu osoby posiadającej pozwolenie na broń.",
  },
  {
    id: 79,
    question:
      "Zarejestrowanie broni wymagającej pozwolenia na broń potwierdza się w: (art. 13 ust. 4 uobia)",
    answers: {
      a: "karcie rejestracyjnej broni",
      b: "legitymacji osoby dopuszczonej do posiadania broni",
      c: "legitymacji posiadacza broni",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ karta rejestracyjna broni potwierdza rejestrację tylko dla broni pozbawionej cech użytkowych i broni pneumatycznej.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ legitymacja osoby dopuszczonej do posiadania broni nie potwierdza rejestracji broni.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zgodnie z art. 13 ust. 4 uobia, zarejestrowanie broni wymagającej pozwolenia potwierdza się w legitymacji posiadacza broni albo w świadectwie broni.",
  },
  {
    id: 80,
    question:
      "Zarejestrowanie broni wymagającej pozwolenia na broń potwierdza się w: (art. 13 ust. 4 uobia)",
    answers: {
      a: "świadectwie broni",
      b: "legitymacji osoby dopuszczonej do posiadania broni",
      c: "karcie rejestracyjnej broni",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ legitymacja osoby dopuszczonej do posiadania broni nie służy do potwierdzania rejestracji broni.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ karta rejestracyjna broni jest używana do potwierdzania rejestracji broni palnej pozbawionej cech użytkowych lub broni pneumatycznej.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z art. 13 ust. 4 uobia, zarejestrowanie broni wymagającej pozwolenia potwierdza się w świadectwie broni albo legitymacji posiadacza broni.",
  },
  {
    id: 81,
    question:
      "Zarejestrowanie broni palnej pozbawionej cech użytkowych oraz broni pneumatycznej potwierdza się w: (art. 13 ust. 5 uobia)",
    answers: {
      a: "legitymacji posiadacza broni, która jest wydawana posiadaczowi broni",
      b: "karcie rejestracyjnej broni, która jest wydawana posiadaczowi broni",
      c: "legitymacji osoby dopuszczonej do posiadania broni, która jest wydawana posiadaczowi broni",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ rejestracja broni palnej pozbawionej cech użytkowych i broni pneumatycznej nie jest potwierdzana w legitymacji posiadacza broni, lecz w karcie rejestracyjnej broni.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ legitymacja osoby dopuszczonej do posiadania broni nie jest stosowana do potwierdzania rejestracji broni.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z art. 13 ust. 5 uobia, zarejestrowanie broni palnej pozbawionej cech użytkowych oraz broni pneumatycznej potwierdza się w karcie rejestracyjnej broni, która jest wydawana posiadaczowi broni.",
  },
  {
    id: 82,
    question:
      "Zarejestrowanie broni palnej pozbawionej cech użytkowych nie może nastąpić na rzecz osoby, która nie ma ukończonych: (art. 13 ust. 6 uobia)",
    answers: {
      a: "21 lat",
      b: "18 lat",
      c: "24 lat",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ dolna granica wiekowa dla rejestracji broni pozbawionej cech użytkowych wynosi 18 lat, a nie 21 lat.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ 24 lata to za wysoki wiek. Dolna granica to 18 lat.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z art. 13 ust. 6 uobia, zarejestrowanie broni palnej pozbawionej cech użytkowych nie może nastąpić na rzecz osoby, która nie ma ukończonych 18 lat.",
  },
  {
    id: 83,
    question:
      "Broń pneumatyczna nie może być zarejestrowana na rzecz osoby, która nie ma ukończonych: (art. 13 ust. 7 uobia)",
    answers: {
      a: "24 lat",
      b: "21 lat",
      c: "18 lat",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ granica wieku dla rejestracji broni pneumatycznej wynosi 18 lat, a nie 24 lata.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ 21 lat to za wysoka granica. Wymagana minimalna granica wieku wynosi 18 lat.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zgodnie z art. 13 ust. 7 uobia, broń pneumatyczna nie może być zarejestrowana na rzecz osoby, która nie ma ukończonych 18 lat.",
  },
  {
    id: 84,
    question: "Amunicję można nabywać na podstawie: (art. 14 uobia)",
    answers: {
      a: "legitymacji posiadacza broni, wyłącznie dla tej broni, która jest określona w legitymacji",
      b: "legitymacji posiadacza broni, dla każdego rodzaju broni",
      c: "legitymacji osoby dopuszczonej do posiadania broni",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ amunicję można nabywać tylko dla tej broni, która jest określona w legitymacji.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ legitymacja osoby dopuszczonej do posiadania broni nie uprawnia do nabywania amunicji.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z art. 14 uobia, amunicję można nabywać na podstawie legitymacji posiadacza broni wyłącznie dla tej broni, która jest określona w legitymacji.",
  },
  {
    id: 85,
    question: "Amunicję można nabywać na podstawie: (art. 14 uobia)",
    answers: {
      a: "legitymacji osoby dopuszczonej do posiadania broni",
      b: "świadectwa broni i pisemnego zamówienia podmiotu uprawnionego do nabycia amunicji",
      c: "karty rejestracyjnej broni",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ legitymacja osoby dopuszczonej do posiadania broni nie uprawnia do nabywania amunicji.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ karta rejestracyjna broni nie jest dokumentem uprawniającym do nabywania amunicji.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z art. 14 uobia, amunicję można nabywać na podstawie świadectwa broni i pisemnego zamówienia podmiotu uprawnionego do nabycia amunicji.",
  },
  {
    id: 86,
    question:
      "Pozwolenia na broń nie wydaje się osobom: (art. 15 ust. 1 uobia)",
    answers: {
      a: "niemającym ukończonych 24 lat",
      b: "używającym alkoholu",
      c: "o znacznie ograniczonej sprawności psychofizycznej",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ pozwolenie na broń nie jest wydawane osobom niemającym ukończonych 21 lat, a nie 24 lat.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ ustawa wymienia osoby uzależnione od alkoholu, a nie osoby jedynie używające alkoholu.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zgodnie z art. 15 ust. 1 uobia, pozwolenie na broń nie jest wydawane osobom o znacznie ograniczonej sprawności psychofizycznej.",
  },
  {
    id: 87,
    question:
      "Pozwolenia na broń nie wydaje się osobom: (art. 15 ust. 1 uobia)",
    answers: {
      a: "o obniżonej sprawności fizycznej",
      b: "wykazującym istotne zaburzenia funkcjonowania psychologicznego",
      c: "niemającym ukończonych 24 lat",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ obniżona sprawność fizyczna nie jest przesłanką do odmowy wydania pozwolenia na broń.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ minimalny wiek, od którego można otrzymać pozwolenie na broń, wynosi 21 lat, a nie 24 lata.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z art. 15 ust. 1 uobia, pozwolenia na broń nie wydaje się osobom wykazującym istotne zaburzenia funkcjonowania psychologicznego.",
  },
  {
    id: 88,
    question:
      "Pozwolenia na broń nie wydaje się osobom: (art. 15 ust. 1 uobia)",
    answers: {
      a: "uzależnionym od alkoholu lub od substancji psychoaktywnych",
      b: "o obniżonej sprawności intelektualnej",
      c: "odpowiedzi a. i b. są prawidłowe",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest częściowo poprawna, ponieważ pozwolenie na broń nie jest wydawane osobom uzależnionym od alkoholu lub od substancji psychoaktywnych.",
      b: "Odpowiedź 'b' jest również poprawna, ponieważ osoby o obniżonej sprawności intelektualnej nie otrzymają pozwolenia na broń.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zarówno osoby uzależnione od alkoholu lub substancji psychoaktywnych, jak i osoby o obniżonej sprawności intelektualnej nie mogą otrzymać pozwolenia na broń, zgodnie z art. 15 ust. 1 uobia.",
  },
  {
    id: 89,
    question:
      "Pozwolenia na broń nie wydaje się osobom: (art. 15 ust. 1 uobia)",
    answers: {
      a: "nieposiadającym obywatelstwa polskiego i miejsca zameldowania na terytorium Rzeczypospolitej Polskiej",
      b: "nieposiadającym miejsca stałego pobytu na terytorium Rzeczypospolitej Polskiej",
      c: "niebędącym obywatelami Rzeczypospolitej Polskiej",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ ustawa nie łączy obowiązkowo obywatelstwa polskiego z miejscem zameldowania w kontekście wydania pozwolenia.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ pozwolenie może być wydane obywatelom innych państw, o ile mają stałe miejsce pobytu w Polsce.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z art. 15 ust. 1 uobia, pozwolenia na broń nie wydaje się osobom nieposiadającym miejsca stałego pobytu na terytorium Rzeczypospolitej Polskiej.",
  },
  {
    id: 90,
    question:
      "Pozwolenia na broń nie wydaje się osobom: (art. 15 ust. 1 uobia)",
    answers: {
      a: "skazanym prawomocnym orzeczeniem sądu w sprawie o wykroczenie",
      b: "skazanym prawomocnym orzeczeniem sądu za nieumyślne przestępstwo przeciwko mieniu",
      c: "skazanym prawomocnym orzeczeniem sądu za umyślne przestępstwo lub umyślne przestępstwo skarbowe",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ wykroczenia nie są podstawą do odmowy wydania pozwolenia na broń.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ nieumyślne przestępstwa przeciwko mieniu nie są bezpośrednią przesłanką odmowy wydania pozwolenia na broń.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zgodnie z art. 15 ust. 1 uobia, pozwolenia na broń nie wydaje się osobom skazanym prawomocnym orzeczeniem sądu za umyślne przestępstwo lub umyślne przestępstwo skarbowe.",
  },
  {
    id: 91,
    question:
      "Na wniosek szkoły, organizacji sportowej, Polskiego Związku Łowieckiego, stowarzyszenia obronnego pozwolenie na broń służącą do celów sportowych lub łowieckich może być wydane osobie mającej ukończone: (art. 15 ust. 2 uobia)",
    answers: {
      a: "18 lat",
      b: "17 lat",
      c: "16 lat",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ minimalny wiek to 18 lat, a nie 17 lat.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ minimalny wiek wynosi 18 lat, a nie 16 lat.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z art. 15 ust. 2 uobia, na wniosek szkoły, organizacji sportowej, Polskiego Związku Łowieckiego lub stowarzyszenia obronnego pozwolenie na broń służącą do celów sportowych lub łowieckich może być wydane osobie mającej ukończone 18 lat.",
  },
  {
    id: 92,
    question:
      "Osoba, która występuje z wnioskiem o wydanie pozwolenia na broń, lub osoba, która zgłasza do rejestru broń pneumatyczną, przedstawiają właściwemu organowi Policji: (art. 15 ust. 3 uobia)",
    answers: {
      a: "wyłącznie orzeczenie lekarskie potwierdzające, że może dysponować bronią",
      b: "wyłącznie orzeczenie psychologiczne potwierdzające, że może dysponować bronią",
      c: "orzeczenia lekarskie i psychologiczne potwierdzające, że może dysponować bronią",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ wymagane są zarówno orzeczenia lekarskie, jak i psychologiczne.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ samo orzeczenie psychologiczne nie wystarczy – konieczne są również orzeczenia lekarskie.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zgodnie z art. 15 ust. 3 uobia, osoba występująca z wnioskiem o wydanie pozwolenia na broń musi przedstawić zarówno orzeczenia lekarskie, jak i psychologiczne potwierdzające, że może dysponować bronią.",
  },
  {
    id: 93,
    question:
      "Osoba posiadająca pozwolenie na broń wydane w celach ochrony osobistej obowiązana jest przedstawić właściwemu organowi Policji orzeczenia lekarskie i psychologiczne potwierdzające, że może dysponować bronią: (art. 15 ust. 4 uobia)",
    answers: {
      a: "raz na 3 lata",
      b: "raz na 5 lat",
      c: "nie ma takiego obowiązku",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ obowiązek przedstawiania orzeczeń lekarskich i psychologicznych dotyczy okresu co 5 lat, a nie 3 lata.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ taki obowiązek istnieje i musi być spełniany co 5 lat.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z art. 15 ust. 4 uobia, osoba posiadająca pozwolenie na broń wydane w celach ochrony osobistej musi przedstawić orzeczenia lekarskie i psychologiczne co 5 lat.",
  },
  {
    id: 94,
    question:
      "Osoba posiadająca pozwolenie na broń wydane w celach kolekcjonerskich, obowiązana jest przedstawić właściwemu organowi Policji orzeczenia lekarskie i psychologiczne potwierdzające, że może dysponować bronią: (art. 15 ust. 4 uobia)",
    answers: {
      a: "nie ma takiego obowiązku",
      b: "raz na 3 lata",
      c: "raz na 5 lat",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ badania te nie muszą być powtarzane co 3 lata w przypadku broni kolekcjonerskiej.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ nie istnieje obowiązek przedstawiania tych badań co 5 lat dla celów kolekcjonerskich.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z art. 15 ust. 4 uobia, osoba posiadająca pozwolenie na broń wydane w celach kolekcjonerskich nie ma obowiązku powtarzania badań lekarskich i psychologicznych, które przeprowadza się jednorazowo przy uzyskiwaniu pozwolenia.",
  },
  {
    id: 95,
    question:
      "W przypadku ujawnienia okoliczności dostatecznie uzasadniających podejrzenie, iż osoba posiadająca pozwolenie na broń lub zarejestrowaną broń pneumatyczną należy do osób uzależnionych od alkoholu lub od substancji psychoaktywnych, właściwy organ Policji może: (art. 15 ust. 5 uobia)",
    answers: {
      a: "zobowiązać tę osobę do niezwłocznego poddania się badaniom lekarskim i psychologicznym i przedstawienia wydanych orzeczeń",
      b: "zobowiązać tę osobę do niezwłocznego poddania się badaniom lekarskim i przedstawienia wydanego orzeczenia",
      c: "zobowiązać tę osobę do niezwłocznego poddania się badaniom psychologicznym i przedstawienia wydanego orzeczenia",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ konieczne są zarówno badania lekarskie, jak i psychologiczne, a nie tylko lekarskie.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ konieczne są zarówno badania lekarskie, jak i psychologiczne, a nie tylko psychologiczne.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z art. 15 ust. 5 uobia, w przypadku podejrzenia uzależnienia od alkoholu lub substancji psychoaktywnych, Policja może zobowiązać osobę do niezwłocznego poddania się badaniom lekarskim i psychologicznym oraz przedstawienia wydanych orzeczeń.",
  },
  {
    id: 96,
    question:
      "Od orzeczenia lekarskiego lub psychologicznego przysługuje odwołanie: (art. 15h ust. 1 uobia)",
    answers: {
      a: "nie przysługuje odwołanie",
      b: "wnoszone ustnie",
      c: "wnoszone na piśmie",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ od orzeczenia przysługuje odwołanie.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ odwołanie musi być wniesione na piśmie, a nie ustnie.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zgodnie z art. 15h ust. 1 uobia, odwołanie od orzeczenia lekarskiego lub psychologicznego przysługuje w formie pisemnej.",
  },
  {
    id: 97,
    question:
      "Odwołanie od orzeczenia lekarskiego lub psychologicznego przysługuje: (art. 15h ust. 2 uobia)",
    answers: {
      a: "wyłącznie komendantowi wojewódzkiemu Policji właściwemu ze względu na miejsce zamieszkania osoby ubiegającej się o pozwolenie na broń",
      b: "osobie ubiegającej się o pozwolenie na broń oraz komendantowi wojewódzkiemu Policji właściwemu ze względu na miejsce zamieszkania tej osoby",
      c: "wyłącznie osobie ubiegającej się o pozwolenie na broń",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ odwołanie przysługuje również osobie ubiegającej się o pozwolenie na broń.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ odwołanie przysługuje zarówno osobie ubiegającej się o pozwolenie, jak i komendantowi wojewódzkiemu Policji.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z art. 15h ust. 2 uobia, odwołanie od orzeczenia lekarskiego lub psychologicznego przysługuje zarówno osobie ubiegającej się o pozwolenie na broń, jak i komendantowi wojewódzkiemu Policji właściwemu ze względu na miejsce zamieszkania tej osoby.",
  },
  {
    id: 98,
    question:
      "Odwołanie od orzeczenia lekarskiego lub psychologicznego wraz z jego uzasadnieniem wnosi się w terminie: (art. 15h ust. 3 uobia)",
    answers: {
      a: "7 dni od dnia doręczenia orzeczenia",
      b: "30 dni od dnia doręczenia orzeczenia",
      c: "14 dni od dnia doręczenia orzeczenia",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ odwołanie wnosi się w terminie dłuższym niż 7 dni.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ odwołanie wnosi się w terminie 30 dni, a nie 14 dni.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z art. 15h ust. 3 uobia, odwołanie od orzeczenia lekarskiego lub psychologicznego wnosi się w terminie 30 dni od dnia doręczenia orzeczenia.",
  },
  {
    id: 99,
    question:
      "Właściwy organ Policji może odmówić wydania pozwolenia na broń osobie, która naruszyła: (art. 17 ust. 1 uobia)",
    answers: {
      a: "warunki określone w pozwoleniu na broń dotyczące ograniczenia lub wykluczenia jej noszenia",
      b: "przepisy regulaminu określającego zasady zachowania bezpieczeństwa na strzelnicy",
      c: "obowiązek zawiadomienia o zmianie miejsca zameldowania",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ naruszenie przepisów regulaminu strzelnicy nie jest wymienione w art. 17 ust. 1 uobia jako przesłanka odmowy wydania pozwolenia na broń.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ chodzi o obowiązek zawiadomienia o zmianie miejsca stałego pobytu, nie zameldowania.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z art. 17 ust. 1 uobia, naruszenie warunków określonych w pozwoleniu na broń, w tym ograniczeń lub wykluczeń jej noszenia, może być podstawą do odmowy wydania pozwolenia.",
  },
  {
    id: 100,
    question:
      "Właściwy organ Policji może odmówić wydania pozwolenia na broń osobie, która naruszyła: (art. 17 ust. 1 uobia)",
    answers: {
      a: "obowiązek pisemnego zgłoszenia przywozu broni lub amunicji przy przekraczaniu granicy",
      b: "przepisy regulaminu określającego zasady zachowania bezpieczeństwa na strzelnicy",
      c: "obowiązek zawiadomienia o zmianie miejsca stałego pobytu",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ obowiązek przywozu broni dotyczy innych kwestii niż odmowa wydania pozwolenia.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ naruszenie przepisów strzelnicy nie jest bezpośrednią przesłanką odmowy wydania pozwolenia na broń.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zgodnie z art. 17 ust. 1 uobia, Policja może odmówić wydania pozwolenia na broń osobie, która nie dopełniła obowiązku zawiadomienia o zmianie miejsca stałego pobytu.",
  },
  {
    id: 101,
    question:
      "Właściwy organ Policji może odmówić wydania pozwolenia na broń osobie, która: (art. 17 ust. 1 uobia)",
    answers: {
      a: "została ukarana mandatem za wykroczenie w ruchu drogowym",
      b: "naruszyła obowiązek rejestracji broni w ciągu 5 dni od dnia jej nabycia",
      c: "naruszyła obowiązek pisemnego zgłoszenia przywozu broni lub amunicji przy przekraczaniu granicy",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ mandat za wykroczenie drogowe nie stanowi przesłanki do odmowy wydania pozwolenia na broń.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ dotyczy innego obowiązku, który nie stanowi bezpośredniej podstawy odmowy wydania pozwolenia.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z art. 17 ust. 1 uobia, naruszenie obowiązku rejestracji broni w terminie 5 dni może być podstawą do odmowy wydania pozwolenia na broń.",
  },
  {
    id: 102,
    question:
      "Właściwy organ Policji cofa pozwolenie na broń, jeżeli osoba, której takie pozwolenie wydano: (art. 18 ust. 1 uobia)",
    answers: {
      a: "naruszyła zasady przechowywania broni",
      b: "posiada przy sobie magazynek do broni, której nie posiada",
      c: "nie przestrzega warunków określonych w pozwoleniu na broń dotyczących ograniczenia lub wykluczenia jej noszenia",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'b' jest nieprawidłowa, ponieważ posiadanie magazynka do broni, której się nie posiada, nie jest bezpośrednią przesłanką do cofnięcia pozwolenia.",
      b: "Odpowiedź 'c' jest nieprawidłowa, ponieważ ten konkretny art. uobia nie wskazuje naruszenia zasad przechowywania broni jako podstawy do cofnięcia pozwolenia na broń.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zgodnie z art. 18 ust. 1 uobia, właściwy organ Policji cofa pozwolenie na broń w przypadku naruszenia zakazu lub ograniczenia możliwości noszenia broni.",
  },
  {
    id: 103,
    question:
      "Właściwy organ Policji cofa pozwolenie na broń, jeżeli osoba, której takie pozwolenie wydano: (art. 18 ust. 1 uobia)",
    answers: {
      a: "naruszyła obowiązek zawiadomienia o utracie broni",
      b: "nie zawiadomiła o zmianie szafy do przechowywania broni",
      c: "nie zawiadomiła o wyjeździe z bronią na zawody sportowe za granicę",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ zmiana szafy do przechowywania broni nie stanowi bezpośredniej przesłanki do cofnięcia pozwolenia.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ wyjazd z bronią na zawody sportowe nie jest podstawą do cofnięcia pozwolenia.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z art. 18 ust. 1 uobia, naruszenie obowiązku zawiadomienia o utracie broni jest podstawą do cofnięcia pozwolenia na broń.",
  },
  {
    id: 104,
    question:
      "Właściwy organ Policji cofa pozwolenie na broń, jeżeli osoba, której takie pozwolenie wydano: (art. 18 ust. 1 uobia)",
    answers: {
      a: "została skazana prawomocnym orzeczeniem sądu w sprawie o wykroczenie",
      b: "zostały jej przedstawione zarzuty popełnienia przestępstwa umyślnego",
      c: "została skazana prawomocnym orzeczeniem sądu za umyślne przestępstwo lub umyślne przestępstwo skarbowe",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ wykroczenie nie jest podstawą do cofnięcia pozwolenia na broń.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ zarzuty nie są wystarczającą przesłanką do cofnięcia pozwolenia — wymagane jest prawomocne skazanie.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zgodnie z art. 18 ust. 1 uobia, prawomocne skazanie za umyślne przestępstwo lub umyślne przestępstwo skarbowe prowadzi do cofnięcia pozwolenia na broń.",
  },
  {
    id: 105,
    question:
      "Właściwy organ Policji cofa pozwolenie na broń, jeżeli osoba, której takie pozwolenie wydano: (art. 18 ust. 1 uobia)",
    answers: {
      a: "przemieszcza się z rozładowaną bronią, znajdując się w stanie po użyciu alkoholu, środka odurzającego lub substancji psychotropowej albo środka zastępczego",
      b: "nosi broń znajdując się w stanie po użyciu alkoholu, środka odurzającego lub substancji psychotropowej albo środka zastępczego",
      c: "odpowiedzi a. i b. są prawidłowe",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest poprawna, ponieważ przemieszczenie się z bronią w stanie po spożyciu alkoholu lub narkotyków skutkuje cofnięciem pozwolenia na broń.",
      b: "Odpowiedź 'b' jest poprawna, ponieważ noszenie broni w stanie po użyciu środków odurzających również skutkuje cofnięciem pozwolenia.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zarówno przemieszczanie się z rozładowaną bronią, jak i noszenie broni w stanie po użyciu alkoholu lub narkotyków prowadzi do cofnięcia pozwolenia na broń, zgodnie z art. 18 ust. 1 uobia.",
  },
  {
    id: 106,
    question:
      "Właściwy organ Policji cofa dopuszczenie do posiadania broni, jeżeli osoba dopuszczona do posiadania broni: (art. 18 ust. 2 uobia)",
    answers: {
      a: "naruszyła obowiązek zawiadomienia o utracie broni",
      b: "przemieszcza się z rozładowaną bronią albo nosi broń, znajdując się w stanie po użyciu alkoholu, środka odurzającego lub substancji psychotropowej albo środka zastępczego",
      c: "odpowiedzi a. i b. są prawidłowe",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest poprawna, ponieważ naruszenie obowiązku zawiadomienia o utracie broni prowadzi do cofnięcia dopuszczenia do posiadania broni.",
      b: "Odpowiedź 'b' jest poprawna, ponieważ przemieszczenie się z rozładowaną bronią lub noszenie broni w stanie po spożyciu alkoholu lub substancji psychoaktywnych również skutkuje cofnięciem dopuszczenia.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zarówno naruszenie obowiązku zawiadomienia o utracie broni, jak i posługiwanie się bronią pod wpływem alkoholu lub substancji odurzających są przesłankami do cofnięcia dopuszczenia do posiadania broni.",
  },
  {
    id: 107,
    question:
      "Właściwy organ Policji cofa dopuszczenie do posiadania broni, jeżeli osoba dopuszczona do posiadania broni: (art. 18 ust. 2 uobia)",
    answers: {
      a: "przemieszcza się z rozładowaną bronią, znajdując się w stanie po użyciu alkoholu, środka odurzającego lub substancji psychotropowej albo środka zastępczego",
      b: "nosi broń znajdując się w stanie po użyciu alkoholu, środka odurzającego lub substancji psychotropowej albo środka zastępczego",
      c: "odpowiedzi a. i b. są prawidłowe",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest poprawna, ponieważ przemieszczenie się z bronią w stanie po użyciu alkoholu jest przesłanką do cofnięcia dopuszczenia.",
      b: "Odpowiedź 'b' jest poprawna, ponieważ noszenie broni w stanie po użyciu alkoholu również prowadzi do cofnięcia dopuszczenia.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zarówno przemieszczanie się z rozładowaną bronią, jak i noszenie broni w stanie po użyciu alkoholu lub innych substancji psychoaktywnych skutkuje cofnięciem dopuszczenia do posiadania broni, zgodnie z art. 18 ust. 2 uobia.",
  },
  {
    id: 108,
    question:
      "Właściwy organ Policji cofa dopuszczenie do posiadania broni, jeżeli osoba dopuszczona do posiadania broni: (art. 18 ust. 2 uobia)",
    answers: {
      a: "została skazana prawomocnym orzeczeniem sądu za umyślne przestępstwo lub umyślne przestępstwo skarbowe",
      b: "została skazana prawomocnym orzeczeniem sądu w sprawie o wykroczenie",
      c: "zostały jej przedstawione zarzuty popełnienia umyślnego przestępstwa",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ wykroczenie nie jest podstawą do cofnięcia dopuszczenia.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ same zarzuty nie prowadzą do cofnięcia dopuszczenia do posiadania broni.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ skazanie za umyślne przestępstwo lub umyślne przestępstwo skarbowe jest podstawą do cofnięcia dopuszczenia do posiadania broni.",
  },
  {
    id: 109,
    question:
      "Jeżeli ustały okoliczności faktyczne, które stanowiły podstawę do wydania pozwolenia na broń, właściwy organ Policji: (art. 18 ust. 4 uobia)",
    answers: {
      a: "może zawiesić pozwolenie na broń",
      b: "może cofnąć pozwolenie na broń",
      c: "cofa pozwolenie na broń",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ ustawa nie przewiduje zawieszenia pozwolenia w takich przypadkach.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ cofnięcie pozwolenia nie jest obowiązkowe, a zależy od oceny organu.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z art. 18 ust. 4 uobia, organ Policji może, ale nie musi, cofnąć pozwolenie na broń, jeśli ustały okoliczności, które stanowiły podstawę do jego wydania.",
  },
  {
    id: 110,
    question:
      "Właściwy organ Policji może cofnąć pozwolenie na broń w przypadku naruszenia przez osobę posiadającą pozwolenie: (art. 18 ust. 5 uobia)",
    answers: {
      a: "przepisów regulaminu określającego zasady zachowania bezpieczeństwa na strzelnicy",
      b: "obowiązku rejestracji broni w ciągu 5 dni od dnia jej nabycia",
      c: "obowiązku pisemnego zgłoszenia przywozu broni lub amunicji przy przekraczaniu granicy",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ naruszenie regulaminu strzelnicy nie jest przesłanką do cofnięcia pozwolenia na broń.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ to naruszenie dotyczy innych przepisów.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zgodnie z art. 18 ust. 5 uobia, naruszenie obowiązku rejestracji broni w ciągu 5 dni może skutkować cofnięciem pozwolenia.",
  },
  {
    id: 111,
    question:
      "Właściwy organ Policji może cofnąć pozwolenie na broń w przypadku naruszenia przez osobę posiadającą pozwolenie: (art. 18 ust. 5 uobia)",
    answers: {
      a: "obowiązku zawiadomienia właściwego organu o zmianie miejsca stałego pobytu",
      b: "obowiązku zawiadomienia właściwego organu o miejscu przechowywania broni",
      c: "obowiązku zawiadomienia organu o użyczeniu broni",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ nie ma obowiązku zawiadamiania o zmianie miejsca przechowywania broni w kontekście cofnięcia pozwolenia.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ dotyczy innego obowiązku, który nie stanowi bezpośredniej podstawy cofnięcia pozwolenia.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ naruszenie obowiązku zawiadomienia o zmianie miejsca stałego pobytu w terminie 14 dni może skutkować cofnięciem pozwolenia na broń.",
  },
  {
    id: 112,
    question:
      "Właściwy organ Policji może cofnąć pozwolenie na broń w przypadku naruszenia przez osobę posiadającą pozwolenie: (art. 18 ust. 5 uobia)",
    answers: {
      a: "zasad przechowywania, noszenia oraz ewidencjonowania broni i amunicji",
      b: "wymogu uzyskania zgody na wywóz broni i amunicji za granicę",
      c: "odpowiedzi a. i b. są prawidłowe",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest poprawna, ponieważ naruszenie zasad przechowywania, noszenia i ewidencjonowania broni stanowi podstawę do cofnięcia pozwolenia.",
      b: "Odpowiedź 'b' jest również poprawna, ponieważ brak zgody na wywóz broni za granicę także może skutkować cofnięciem pozwolenia.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ oba te naruszenia są podstawą do cofnięcia pozwolenia na broń.",
  },
  {
    id: 113,
    question:
      "Właściwy organ Policji może cofnąć pozwolenie na broń w przypadku: (art. 18 ust. 5 uobia)",
    answers: {
      a: "używania broni palnej oraz innej broni zdolnej do rażenia celów na odległość, w celach szkoleniowych i sportowych poza strzelnicą",
      b: "naruszenia przez osobę posiadającą pozwolenie zakazu użyczania broni osobie nieupoważnionej",
      c: "odpowiedzi a. i b. są prawidłowe",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest poprawna, ponieważ naruszenie zasad używania broni poza strzelnicą jest podstawą do cofnięcia pozwolenia.",
      b: "Odpowiedź 'b' jest poprawna, ponieważ użyczenie broni osobie nieupoważnionej również może prowadzić do cofnięcia pozwolenia.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zarówno używanie broni poza strzelnicą, jak i użyczenie jej osobie nieupoważnionej są podstawami do cofnięcia pozwolenia.",
  },
  {
    id: 114,
    question:
      "Właściwy organ Policji może cofnąć dopuszczenie do posiadania broni w przypadku naruszenia przez osobę dopuszczoną do posiadania broni (art. 18 ust. 6 uobia)",
    answers: {
      a: "obowiązku zawiadomienia właściwego organu o zmianie miejsca stałego pobytu",
      b: "obowiązku zawiadomienia właściwego organu o miejscu przechowywania broni",
      c: "obowiązku zawiadomienia organu o użyczeniu broni",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ zawiadomienie o miejscu przechowywania broni nie jest wymienione jako podstawa cofnięcia dopuszczenia.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ naruszenie tego obowiązku nie stanowi przesłanki do cofnięcia dopuszczenia do posiadania broni.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ naruszenie obowiązku zawiadomienia o zmianie miejsca stałego pobytu może prowadzić do cofnięcia dopuszczenia do posiadania broni.",
  },
  {
    id: 115,
    question:
      "Właściwy organ Policji może cofnąć dopuszczenie do posiadania broni w przypadku: (art. 18 ust. 6 uobia)",
    answers: {
      a: "naruszenia przez osobę dopuszczoną do posiadania broni zakazu użyczania broni osobie nieupoważnionej",
      b: "używania broni palnej oraz innej broni zdolnej do rażenia celów na odległość, w celach szkoleniowych i sportowych poza strzelnicą",
      c: "odpowiedzi a. i b. są prawidłowe",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest poprawna, ponieważ naruszenie zakazu użyczania broni osobie nieupoważnionej stanowi podstawę do cofnięcia dopuszczenia.",
      b: "Odpowiedź 'b' jest również poprawna, ponieważ używanie broni palnej poza strzelnicą także może skutkować cofnięciem dopuszczenia.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zarówno naruszenie zakazu użyczania broni, jak i używanie broni poza strzelnicą są podstawą do cofnięcia dopuszczenia.",
  },
  {
    id: 116,
    question:
      "Osoba, której cofnięto pozwolenie na broń, dopuszczenie do posiadania broni lub której unieważniono kartę rejestracyjną broni, jest zobowiązana zwrócić dokumenty potwierdzające legalność posiadania broni i amunicji do właściwego organu Policji w terminie: (art. 18 ust. 8 uobia)",
    answers: {
      a: "14 dni od dnia otrzymania ostatecznej decyzji o cofnięciu pozwolenia na broń, dopuszczenia do posiadania broni lub unieważnienia karty",
      b: "30 dni od dnia otrzymania ostatecznej decyzji o cofnięciu pozwolenia na broń, dopuszczenia do posiadania broni lub unieważnienia karty",
      c: "7 dni od dnia otrzymania ostatecznej decyzji o cofnięciu pozwolenia na broń, dopuszczenia do posiadania broni lub unieważnienia karty",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ termin zwrotu dokumentów wynosi 7 dni.",
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ termin wynosi mniej niż 30 dni.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ osoba ma 7 dni na zwrot dokumentów po otrzymaniu decyzji o cofnięciu pozwolenia lub unieważnieniu karty rejestracyjnej.",
  },
  {
    id: 117,
    question:
      "W przypadku ujawnienia, że osoba posiadająca broń zgodnie z przepisami, została skazana prawomocnym orzeczeniem sądu za umyślne przestępstwo, a zwłoka zagrażałaby bezpieczeństwu publicznego, Policja może: (art. 19 ust. 1 uobia)",
    answers: {
      a: "za pokwitowaniem odebrać broń i amunicję oraz dokumenty potwierdzające legalność posiadania broni",
      b: "za pokwitowaniem odebrać wyłącznie broń i amunicję",
      c: "za pokwitowaniem odebrać wyłącznie dokumenty potwierdzające legalność posiadania broni",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepełna, ponieważ nie uwzględnia dokumentów potwierdzających legalność.",
      c: "Odpowiedź 'c' jest niepełna, ponieważ Policja może odebrać także broń i amunicję.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ w przypadku zagrożenia bezpieczeństwa publicznego, Policja może odebrać zarówno broń, amunicję, jak i dokumenty potwierdzające legalność posiadania broni.",
  },
  {
    id: 118,
    question:
      "W przypadku ujawnienia, że osoba posiadająca broń zgodnie z przepisami, narusza zasady przechowywania, noszenia oraz ewidencjonowania broni i amunicji, a zwłoka zagrażałaby bezpieczeństwu publicznego, Policja może: (art. 19 ust. 1 uobia)",
    answers: {
      a: "za pokwitowaniem odebrać wyłącznie broń i amunicję",
      b: "za pokwitowaniem odebrać broń i amunicję oraz dokumenty potwierdzające legalność posiadania broni",
      c: "za pokwitowaniem odebrać wyłącznie dokumenty potwierdzające legalność posiadania broni",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepełna, ponieważ Policja może również odebrać dokumenty potwierdzające legalność.",
      c: "Odpowiedź 'c' jest niepełna, ponieważ Policja może także odebrać broń i amunicję.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ Policja może odebrać zarówno broń, amunicję, jak i dokumenty potwierdzające legalność posiadania broni w przypadku naruszenia zasad przechowywania, noszenia oraz ewidencjonowania.",
  },
  {
    id: 119,
    question:
      "Policja może za pokwitowaniem odebrać broń i amunicję oraz dokumenty potwierdzające legalność posiadania broni osobie posiadającej broń zgodnie z przepisami, przeciwko której toczy się postępowanie karne o umyślne przestępstwo lub umyślne przestępstwo skarbowe, do czasu prawomocnego zakończenia tego postępowania, na okres nie dłuższy niż: (art. 19 ust. 1a uobia)",
    answers: {
      a: "3 lata",
      b: "4 lata",
      c: "2 lata",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ okres maksymalny to 3 lata.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ okres maksymalny wynosi więcej niż 2 lata.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z ustawą, Policja może odebrać broń, amunicję oraz dokumenty na okres nie dłuższy niż 3 lata.",
  },
  {
    id: 120,
    question:
      "Cofnięcie pozwolenia na broń, dopuszczenia do posiadania broni oraz unieważnienie karty rejestracyjnej broni pneumatycznej następuje: (art. 20 uobia)",
    answers: {
      a: "w drodze zaświadczenia",
      b: "w drodze postanowienia",
      c: "w drodze decyzji administracyjnej",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ cofnięcie pozwolenia nie następuje w drodze zaświadczenia.",
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ nie jest to postanowienie.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ cofnięcie pozwolenia, dopuszczenia oraz unieważnienie karty rejestracyjnej broni pneumatycznej następuje w drodze decyzji administracyjnej.",
  },
  {
    id: 121,
    question:
      "Dopuszcza się zbywanie broni i amunicji do tej broni: (art. 21 ust. 1 uobia)",
    answers: {
      a: "pomiędzy osobami posiadającymi pozwolenie na ten sam rodzaj broni",
      b: "wyłącznie pomiędzy osobami posiadającymi pozwolenie na broń do celów sportowych i łowieckich",
      c: "zbywanie broni i amunicji do tej broni pomiędzy posiadaczami pozwolenia na broń jest zabronione",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ ogranicza zbywanie tylko do celów sportowych i łowieckich.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ zbywanie broni jest dopuszczalne pomiędzy osobami posiadającymi odpowiednie pozwolenia.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z ustawą zbywanie broni i amunicji do tej broni jest dozwolone pomiędzy osobami posiadającymi pozwolenie na ten sam rodzaj broni.",
  },
  {
    id: 122,
    question:
      "Zbywający broń i amunicję do tej broni obowiązany jest powiadomić pisemnie o tym fakcie właściwy organ Policji: (art. 21 ust. 2 uobia)",
    answers: {
      a: "w ciągu 7 dni",
      b: "niezwłocznie",
      c: "w ciągu 14 dni",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ zbywający ma obowiązek powiadomić organ Policji niezwłocznie.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ termin 14 dni jest zbyt długi zgodnie z przepisami.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zbywający broń i amunicję ma obowiązek powiadomić właściwy organ Policji niezwłocznie.",
  },
  {
    id: 123,
    question:
      "Powiadomienie właściwego organu Policji o zbyciu broni i amunicji do tej broni może nastąpić: (art. 21 ust. 2 uobia)",
    answers: {
      a: "ustnie",
      b: "telefonicznie",
      c: "tylko pisemnie",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ powiadomienie musi być pisemne.",
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ powiadomienie telefoniczne nie jest akceptowane.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zgodnie z przepisami, powiadomienie o zbyciu broni musi nastąpić w formie pisemnej.",
  },
  {
    id: 124,
    question:
      "Osoba, która utraciła uprawnienie do posiadania broni lub której unieważniono kartę rejestracyjną broni pneumatycznej, obowiązana jest zbyć broń i amunicję do tej broni: (art. 22 ust. 1 uobia)",
    answers: {
      a: "niezwłocznie",
      b: "w ciągu 7 dni",
      c: "w ciągu 30 dni",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ termin jest krótszy niż 7 dni.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ termin 30 dni jest zbyt długi.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ osoba, która utraciła uprawnienie, musi zbyć broń i amunicję niezwłocznie.",
  },
  {
    id: 125,
    question:
      "Osoba, która utraciła uprawnienie do posiadania broni lub której unieważniono kartę rejestracyjną broni pneumatycznej, jest obowiązana niezwłocznie: (art. 22 ust. 1 uobia)",
    answers: {
      a: "powiadomić o miejscu przechowywania broni i amunicji najbliższą jednostkę Policji",
      b: "zbyć broń i amunicję do tej broni",
      c: "przekazać klucze do szafy na broń osobie, która posiada pozwolenie na broń",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ obowiązkiem jest zbycie broni, a nie powiadomienie o miejscu przechowywania.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ klucze do szafy nie są przedmiotem przepisów związanych ze zbyciem broni.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ osoba, która utraciła uprawnienie do posiadania broni, jest obowiązana niezwłocznie zbyć broń i amunicję do tej broni.",
  },
  {
    id: 126,
    question:
      "Osoba, która utraciła uprawnienie do posiadania broni lub której unieważniono kartę rejestracyjną broni pneumatycznej, jest obowiązana niezwłocznie: (art. 22 ust. 1a uobia)",
    answers: {
      a: "złożyć broń i amunicję do tej broni do depozytu",
      b: "zbyć lub pozbawić broń palną cech użytkowych",
      c: "przekazać klucze do szafy na broń osobie, która posiada pozwolenie na broń",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepełna, ponieważ obowiązek obejmuje także możliwość pozbawienia broni palnej cech użytkowych.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ przepisy nie przewidują obowiązku przekazania kluczy do szafy.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ za wykonanie obowiązku zbycia broni uznaje się także pozbawienie jej cech użytkowych.",
  },
  {
    id: 127,
    question:
      "W przypadku utraty pozwolenia na broń, jeżeli broń nie zostanie zbyta, należy ją złożyć wraz z amunicją do depozytu właściwego organu Policji: (art. 22 ust. 3 uobia)",
    answers: {
      a: "w terminie 30 dni od utraty pozwolenia",
      b: "w terminie 14 dni od utraty pozwolenia",
      c: "w terminie 7 dni od utraty pozwolenia",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ zgodnie z ustawą termin wynosi 30 dni.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ termin jest dłuższy niż 7 dni.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgodnie z ustawą, broń i amunicję należy złożyć do depozytu w terminie 30 dni od utraty pozwolenia.",
  },
  {
    id: 128,
    question:
      "Koszty związane z deponowaniem broni i amunicji w przypadku utraty pozwolenia na broń ponosi: (art. 23 ust. 1)",
    answers: {
      a: "w opisanym przypadku deponowanie broni i amunicji jest bezpłatne",
      b: "Policja",
      c: "osoba, która utraciła prawo do posiadania broni i amunicji do niej",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ deponowanie nie jest bezpłatne dla osoby, która utraciła prawo do posiadania broni.",
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ to nie Policja ponosi koszty deponowania w tym przypadku.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ osoba, która utraciła prawo do posiadania broni, ponosi koszty związane z deponowaniem broni i amunicji.",
  },
  {
    id: 129,
    question:
      "Posiadacz broni w przypadku jej utraty jest zobowiązany niezwłocznie, nie później jednak niż w ciągu 24 godzin od chwili stwierdzenia utraty broni: (art. 25 uobia)",
    answers: {
      a: "zawiadomić o tym Policję albo Żandarmerię Wojskową",
      b: "zawiadomić o tym Policję albo Prokuraturę",
      c: "zawiadomić o tym Policję albo Straż Graniczną",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ Policja i Żandarmeria są właściwe do przyjęcia zgłoszenia.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ nie dotyczy Straży Granicznej.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ osoba musi niezwłocznie powiadomić Policję albo Żandarmerię Wojskową.",
  },
  {
    id: 130,
    question:
      "Posiadacz broni w przypadku jej utraty jest zobowiązany zawiadomić o tym Policję albo Żandarmerię Wojskową: (art. 25 uobia)",
    answers: {
      a: "niezwłocznie, nie później jednak niż w ciągu 72 godzin od chwili stwierdzenia utraty broni",
      b: "niezwłocznie, nie później jednak niż w ciągu 48 godzin od chwili stwierdzenia utraty broni",
      c: "niezwłocznie, nie później jednak niż w ciągu 24 godzin od chwili stwierdzenia utraty broni",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ termin wynosi maksymalnie 24 godziny.",
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ termin wynosi mniej niż 48 godzin.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ osoba musi zawiadomić Policję albo Żandarmerię nie później niż 24 godziny od stwierdzenia utraty broni.",
  },
  {
    id: 131,
    question:
      "Osoba posiadająca pozwolenie na broń lub posiadająca broń podlegającą rejestracji, która nie wymaga pozwolenia na broń, jest obowiązana w razie zmiany miejsca stałego pobytu zawiadomić o tym fakcie pisemnie, organ Policji właściwy ze względu na nowe miejsce stałego pobytu: (art. 26 uobia)",
    answers: {
      a: "w terminie 14 dni od dnia zmiany miejsca stałego pobytu",
      b: "w terminie 30 dni od dnia zmiany miejsca stałego pobytu",
      c: "w terminie 7 dni od dnia zmiany miejsca stałego pobytu",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ termin wynosi 14 dni.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ termin wynosi więcej niż 7 dni.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ osoba musi zawiadomić organ Policji w terminie 14 dni.",
  },
  {
    id: 132,
    question:
      "Osoba posiadająca pozwolenie na broń lub posiadająca broń podlegającą rejestracji, która nie wymaga pozwolenia na broń, jest obowiązana w razie zmiany miejsca stałego pobytu zawiadomić o tym fakcie pisemnie, w terminie 14 dni od dnia zmiany miejsca stałego pobytu: (art. 26 uobia)",
    answers: {
      a: "organ Policji właściwy ze względu na dotychczasowe lub nowe miejsce stałego pobytu",
      b: "organ Policji właściwy ze względu na nowe miejsce stałego pobytu",
      c: "organ Policji właściwy ze względu na dotychczasowe miejsce stałego pobytu",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ organ właściwy dla nowego miejsca pobytu musi być powiadomiony.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ zawiadomienie musi dotyczyć nowego miejsca.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ osoba musi zawiadomić organ Policji właściwy dla nowego miejsca pobytu.",
  },
  {
    id: 133,
    question:
      "Broni odpowiadającej celom łowieckim i broni odpowiadającej celom sportowym oraz amunicji do takiej broni można użyczać osobom posiadającym pozwolenie na broń wydane w celach: (art. 28 uobia)",
    answers: {
      a: "kolekcjonerskich lub sportowych",
      b: "łowieckich lub sportowych",
      c: "szkoleniowych lub łowieckich",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ dotyczy celów łowieckich lub sportowych.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ nie dotyczy celów szkoleniowych.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ broń można użyczać osobom posiadającym pozwolenie na broń w celach łowieckich lub sportowych.",
  },
  {
    id: 134,
    question:
      "Osoby posiadające pozwolenie na broń wydane w celach łowieckich lub sportowych mogą użyczać broń odpowiadającą celom łowieckim lub sportowym od osób posiadających pozwolenie wydane w celu: (art. 28 uobia)",
    answers: {
      a: "sportowym",
      b: "kolekcjonerskim",
      c: "odpowiedzi a. i b. są prawidłowe",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest poprawna, ale niepełna.",
      b: "Odpowiedź 'b' jest poprawna, ale niepełna.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ broń można użyczać osobom posiadającym pozwolenia w celach sportowych lub kolekcjonerskich.",
  },
  {
    id: 135,
    question: "Świadectwo broni może być wydane: (art. 29 ust. 1 uobia)",
    answers: {
      a: "podmiotom prowadzącym strzelnicę",
      b: "osobom fizycznym posiadającym pozwolenie na broń",
      c: "prywatnym placówkom muzealnym",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ świadectwo broni wydaje się podmiotom, a nie osobom fizycznym.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ nie dotyczy prywatnych placówek muzealnych.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ świadectwo broni może być wydane podmiotom prowadzącym strzelnicę.",
  },
  {
    id: 136,
    question: "Świadectwo broni może być wydane: (art. 29 ust. 1 uobia)",
    answers: {
      a: "osobom fizycznym wpisanym na listę kwalifikowanych pracowników ochrony fizycznej",
      b: "podmiotom wykonującym zadania związane z realizacją filmów i innych przedsięwzięć artystycznych",
      c: "osobom posiadającym dopuszczenie do posiadania broni",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ świadectwo broni dotyczy podmiotów, a nie osób fizycznych.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ świadectwo nie jest wydawane osobom z dopuszczeniem.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ świadectwo broni może być wydane podmiotom związanym z realizacją filmów i przedsięwzięć artystycznych.",
  },
  {
    id: 137,
    question:
      "Świadectwo na broń, uprawniające do posiadania samoczynnej broni palnej zdolnej do rażenia celów na odległość, może być wydane: (art. 29 ust. 2 uobia)",
    answers: {
      a: "organizatorom kursów, kształcącym w zawodzie pracownika ochrony",
      b: "stowarzyszeniom strzeleckim",
      c: "podmiotom prowadzącym strzelnicę",
    },
    correct: "a",
    explain: {
      a: "Odpowiedź 'a' jest poprawna, ponieważ dotyczy organizatorów kursów w zawodzie pracownika ochrony.",
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ nie dotyczy wydania świadectwa na broń samoczynną.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ podmioty prowadzące strzelnicę nie mogą uzyskać takiego świadectwa.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ świadectwo broni uprawniające do posiadania broni samoczynnej może być wydane organizatorom kursów ochroniarskich.",
  },
  {
    id: 138,
    question: "Dopuszczenie do posiadania broni uprawnia osoby fizyczne do:",
    answers: {
      a: "korzystania z broni na strzelnicy bez nadzoru prowadzącego strzelanie",
      b: "posługiwania się bronią podmiotów posiadających świadectwo broni, przy wykonywaniu zadań w ramach prowadzonej działalności",
      c: "odpowiedzi a. i b. są prawidłowe",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ dopuszczenie nie uprawnia do korzystania z broni bez nadzoru na strzelnicy.",
      b: "Odpowiedź 'b' jest poprawna, ponieważ dopuszczenie pozwala na posługiwanie się bronią podmiotów posiadających świadectwo broni.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ tylko posługiwanie się bronią w ramach działalności jest dopuszczone.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ dopuszczenie do posiadania broni uprawnia do posługiwania się bronią podmiotów posiadających świadectwo broni w ramach wykonywanych zadań.",
  },
  {
    id: 139,
    question:
      "Dopuszczenia do posiadania broni nie wydaje się osobom: (art. 30 ust. 1 uobia)",
    answers: {
      a: "o znacznie ograniczonej sprawności psychofizycznej",
      b: "niemającym ukończonych 24 lat",
      c: "używającym alkoholu",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ wiek nie jest jedynym ograniczeniem.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ dotyczy tylko ograniczeń psychofizycznych.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ osoby o znacznie ograniczonej sprawności psychofizycznej nie mogą uzyskać dopuszczenia do posiadania broni.",
  },
  {
    id: 140,
    question:
      "Dopuszczenia do posiadania broni nie wydaje się osobom: (art. 30 ust. 1 uobia)",
    answers: {
      a: "wykazującym istotne zaburzenia funkcjonowania psychologicznego",
      b: "o obniżonej sprawności fizycznej",
      c: "niemającym ukończonych 24 lat",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ sprawność fizyczna nie jest decydująca.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ wiek 24 lat nie stanowi wyłącznej przeszkody.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zaburzenia funkcjonowania psychologicznego są przeszkodą w uzyskaniu dopuszczenia.",
  },
  {
    id: 141,
    question:
      "Dopuszczenia do posiadania broni nie wydaje się osobom: (art. 30 ust. 1 uobia)",
    answers: {
      a: "które nie ukończyły 24 lat",
      b: "uzależnionym od alkoholu lub od substancji psychoaktywnych",
      c: "o obniżonej sprawności fizycznej",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepełna, uzależnienie od alkoholu lub substancji psychoaktywnych jest ważniejszym kryterium.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ sprawność fizyczna nie jest kryterium eliminującym.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ uzależnienie od alkoholu lub substancji psychoaktywnych stanowi przeszkodę w uzyskaniu dopuszczenia.",
  },
  {
    id: 142,
    question:
      "Dopuszczenia do posiadania broni nie wydaje się osobom: (art. 30 ust. 1 uobia)",
    answers: {
      a: "nieposiadającym miejsca stałego pobytu na terytorium Rzeczypospolitej Polskiej",
      b: "nieposiadającym miejsca zameldowania na terytorium Rzeczypospolitej Polskiej",
      c: "niebędącym obywatelami Rzeczypospolitej Polskiej",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ miejsce zameldowania nie jest warunkiem.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ dopuszczenia mogą uzyskać cudzoziemcy z miejscem pobytu.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ brak miejsca stałego pobytu na terenie Polski uniemożliwia uzyskanie dopuszczenia.",
  },
  {
    id: 143,
    question:
      "Dopuszczenia do posiadania broni nie wydaje się osobom: (art. 30 ust. 1 uobia)",
    answers: {
      a: "skazanym prawomocnym orzeczeniem sądu w sprawie o wykroczenie",
      b: "skazanym prawomocnym orzeczeniem sądu za umyślne przestępstwo lub umyślne przestępstwo skarbowe",
      c: "skazanym prawomocnym orzeczeniem sądu za nieumyślne przestępstwo przeciwko mieniu",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ wykroczenie nie jest przeszkodą.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ kluczowe jest umyślne przestępstwo.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ umyślne przestępstwo lub umyślne przestępstwo skarbowe stanowią przeszkodę w uzyskaniu dopuszczenia.",
  },
  {
    id: 144,
    question:
      "Dopuszczenie do posiadania broni następuje: (art. 30 ust. 2 uobia)",
    answers: {
      a: "w drodze postanowienia",
      b: "w drodze zaświadczenia",
      c: "w drodze decyzji administracyjnej",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ nie jest to postanowienie.",
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ nie jest to zaświadczenie.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ dopuszczenie następuje w drodze decyzji administracyjnej.",
  },
  {
    id: 145,
    question:
      "Broń i amunicję należy przechowywać w sposób: (art. 32 ust. 1 uobia)",
    answers: {
      a: "uniemożliwiający dostęp do nich osób nieuprawnionych",
      b: "zapobiegający ich uszkodzeniu",
      c: "niezagrażający innym osobom",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ kluczowy jest brak dostępu dla osób nieuprawnionych.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ główny wymóg to zabezpieczenie przed osobami nieuprawnionymi.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ broń i amunicję należy przechowywać tak, aby uniemożliwić dostęp osobom nieuprawnionym.",
  },
  {
    id: 146,
    question:
      "Podmioty posiadające broń i amunicję na podstawie pozwolenia na broń na okaziciela, przechowują broń i amunicję: (§3 ust. 1 rozporządzenia w sprawie przechowywania, noszenia oraz ewidencjonowania broni i amunicji)",
    answers: {
      a: "w magazynie broni",
      b: "w urządzeniach spełniających wymagania co najmniej klasy S1 według normy PN-EN 14450",
      c: "odpowiedzi a. i b. są prawidłowe",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepełna, ponieważ sprzęt musi spełniać wymagania normy PN-EN 14450.",
      b: "Odpowiedź 'b' jest poprawna, ale niepełna.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ broń musi być przechowywana w magazynie broni lub urządzeniach klasy S1.",
  },
  {
    id: 147,
    question:
      "Podmioty posiadające broń i amunicję na podstawie pozwolenia na broń na okaziciela, przechowują broń: (§3 ust. 2 rozporządzenia w sprawie przechowywania, noszenia oraz ewidencjonowania broni i amunicji)",
    answers: {
      a: "z odłączonym magazynkiem, w stanie rozładowanym",
      b: "z podłączonym magazynkiem, w stanie rozładowanym",
      c: "z podłączonym magazynkiem, w stanie załadowanym",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ broń musi być rozładowana i z odłączonym magazynkiem.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ broń nie może być załadowana.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ broń musi być przechowywana w stanie rozładowanym z odłączonym magazynkiem.",
  },
  {
    id: 148,
    question:
      "Podmioty posiadające broń i amunicję na podstawie pozwolenia na broń na okaziciela, przechowują amunicję: (§3 ust. 3 rozporządzenia w sprawie przechowywania, noszenia oraz ewidencjonowania broni i amunicji)",
    answers: {
      a: "w magazynkach nabojowych",
      b: "w pudełkach lub pojemnikach, w sposób uniemożliwiający uderzenie w spłonkę naboju",
      c: "w dowolny sposób, umożliwiający szybki dostęp do amunicji",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ amunicja musi być przechowywana w sposób zabezpieczający przed uderzeniem w spłonkę.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ nie można przechowywać amunicji w dowolny sposób.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ amunicję należy przechowywać w sposób zabezpieczający przed uderzeniem w spłonkę.",
  },
  {
    id: 149,
    question:
      "Osoby posiadające broń i amunicję do niej na podstawie pozwolenia przechowują broń i amunicję: (§5 ust. 1 rozporządzenia w sprawie przechowywania, noszenia oraz ewidencjonowania broni i amunicji)",
    answers: {
      a: "w urządzeniach spełniających wymagania co najmniej klasy S2 według normy PN-EN 14450",
      b: "w urządzeniach spełniających wymagania co najmniej klasy S1 według normy PN-EN 14450",
      c: "w urządzeniach spełniających wymagania co najmniej klasy 0 według normy PN-EN 1143-1",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ minimalny wymóg to urządzenia klasy S1.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ minimalny wymóg to klasa S1.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ urządzenia klasy S1 spełniają minimalne wymogi do przechowywania broni.",
  },
  {
    id: 150,
    question:
      "W pomieszczeniu wyposażonym w dodatkowe zabezpieczenia, określone w rozporządzeniu w sprawie przechowywania, noszenia oraz ewidencjonowania broni i amunicji, przechowuje się broń w liczbie: (§5 ust. 2 rozporządzenia w sprawie przechowywania, noszenia oraz ewidencjonowania broni i amunicji)",
    answers: {
      a: "powyżej 100 egzemplarzy",
      b: "powyżej 50 egzemplarzy",
      c: "powyżej 20 egzemplarzy",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ obowiązek dotyczy 50 egzemplarzy.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ obowiązek dotyczy więcej niż 50 egzemplarzy.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ broń w liczbie powyżej 50 egzemplarzy musi być przechowywana w pomieszczeniu z dodatkowym zabezpieczeniem.",
  },
  {
    id: 151,
    question:
      "Osoby posiadające broń i amunicję do broni palnej w celach kolekcjonerskich oraz pamiątkowych, w przypadku przechowywania tej broni i amunicji poza urządzeniami spełniającymi wymagania co najmniej klasy S1 według normy PN-EN 14450, mogą je przechowywać: (§6 ust. 1 rozporządzenia w sprawie przechowywania, noszenia oraz ewidencjonowania broni i amunicji)",
    answers: {
      a: "w gablotach przeznaczonych do przechowywania broni",
      b: "na specjalnie przystosowanych regałach",
      c: "przechowywanie broni i amunicji poza urządzeniami spełniającymi wymagania co najmniej klasy S1 według norm PN-EN 14450 jest zabronione",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ obowiązujące przepisy zabraniają przechowywania broni poza urządzeniami spełniającymi wymogi klasy S1.",
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ przystosowane regały nie są wystarczającym zabezpieczeniem.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ przechowywanie broni poza urządzeniami klasy S1 jest zabronione.",
  },
  {
    id: 152,
    question:
      "Broń palną nosi się: (§8 ust. 1 rozporządzenia w sprawie przechowywania, noszenia oraz ewidencjonowania broni i amunicji)",
    answers: {
      a: "wyłącznie w kasetach na broń",
      b: "w pudełku, w którym zakupiono broń",
      c: "kaburach lub futerałach",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ broń można nosić w kaburach lub futerałach, nie tylko w kasetach.",
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ pudełko nie spełnia wymagań dotyczących noszenia broni.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ broń palną nosi się w kaburach lub futerałach.",
  },
  {
    id: 153,
    question:
      "Broń palną przeznaczoną do ochrony osobistej nosi się: (§8 ust. 2 rozporządzenia w sprawie przechowywania, noszenia oraz ewidencjonowania broni i amunicji)",
    answers: {
      a: "w sposób jak najmniej widoczny",
      b: "w sposób umożliwiający jej szybkie dobycie",
      c: "w sposób widoczny, w kaburze przylegającej do ciała",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ broń do ochrony osobistej powinna być noszona jak najmniej widocznie.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ broń nie powinna być widoczna.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ broń do ochrony osobistej należy nosić w sposób jak najmniej widoczny.",
  },
  {
    id: 154,
    question:
      "Zakaz noszenia lub przemieszczania w stanie rozładowanym broni i amunicji, na obszarze całego państwa lub na określonych obszarach, na czas określony, w odniesieniu do wszelkiej broni lub niektórych jej rodzajów, może wprowadzić: (art. 33 ust. 1 uobia)",
    answers: {
      a: "Prezydent, w drodze rozporządzenia",
      b: "minister właściwy do spraw wewnętrznych, w drodze rozporządzenia",
      c: "Komendant Główny Policji, w drodze zarządzenia",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ zakaz wprowadza minister właściwy do spraw wewnętrznych.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ zarządzenie wydaje minister.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ zakaz noszenia i przemieszczania broni może wprowadzić minister właściwy do spraw wewnętrznych.",
  },
  {
    id: 155,
    question:
      "Przewóz broni i amunicji przez terytorium Rzeczypospolitej Polskiej może nastąpić na podstawie: (art. 34 uobia)",
    answers: {
      a: "zaświadczenia wydanego przez właściwego konsula Rzeczypospolitej Polskiej",
      b: "zgody właściwego organu Policji",
      c: "paszportu",
    },
    correct: "a",
    explain: {
      a: "Odpowiedź 'a' jest poprawna, ponieważ przewóz może nastąpić na podstawie zaświadczenia wydanego przez konsula RP.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ zgoda Policji nie jest wymagana w tym przypadku.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ paszport nie wystarcza do przewozu broni i amunicji.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ przewóz broni przez terytorium RP może nastąpić na podstawie zaświadczenia wydanego przez konsula RP.",
  },
  {
    id: 156,
    question:
      "Przewóz broni i amunicji przez terytorium Rzeczypospolitej Polskiej, przez obywateli państwa członkowskiego Unii Europejskiej może nastąpić na podstawie: (art. 34 uobia)",
    answers: {
      a: "paszportu",
      b: "zgody właściwego organu Policji",
      c: "Europejskiej karty broni palnej",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ paszport nie uprawnia do przewozu broni przez obywateli UE.",
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ Europejska karta broni palnej jest wymagana.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ przewóz broni przez obywateli UE może nastąpić na podstawie Europejskiej karty broni palnej.",
  },
  {
    id: 157,
    question:
      "Przewożenie broni i amunicji środkami transportu publicznego: (art. 35 uobia)",
    answers: {
      a: "jest zabronione",
      b: "jest dopuszczalne przy zachowaniu niezbędnych środków bezpieczeństwa, pod warunkiem, że broń i amunicja są zabezpieczone w sposób uniemożliwiający powstanie zagrożenia życia, zdrowia lub mienia",
      c: "jest dozwolone wyłącznie za zgodą właściwego organu Policji",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ przewóz broni jest dopuszczalny przy spełnieniu określonych warunków.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ przewóz nie wymaga zgody Policji.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ przewóz broni środkami transportu publicznego jest dopuszczalny przy zachowaniu środków bezpieczeństwa.",
  },
  {
    id: 158,
    question:
      "Przewożenie broni i amunicji w kabinach pasażerskich statków powietrznych przez osoby inne niż specjalnie do tego upoważnione na podstawie odrębnych przepisów jest: (art. 35 uobia)",
    answers: {
      a: "zakazane",
      b: "dozwolone",
      c: "dozwolone wyłącznie za zgodą właściwego organu Policji",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ przewożenie broni w kabinach pasażerskich jest zakazane.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ nie ma możliwości zgody na przewóz w kabinach pasażerskich.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ przewożenie broni w kabinach pasażerskich jest zakazane.",
  },
  {
    id: 159,
    question:
      "W środkach transportu publicznego, służących do przewozu pasażerów, broń przewozi się: (§2 ust. 1 rozporządzenia w sprawie przewożenia broni i amunicji środkami transportu publicznego)",
    answers: {
      a: "w stanie załadowanym, z amunicją w magazynkach nabojowych",
      b: "w stanie rozładowanym, bez amunicji w komorze nabojowej i w magazynkach nabojowych z wyłączeniem broni do ochrony osobistej oraz ochrony osób i mienia",
      c: "w środkach transportu publicznego przewożenie broni jest zabronione",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ broń musi być przewożona rozładowana.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ przewożenie broni jest dozwolone w stanie rozładowanym.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ broń w środkach transportu publicznego przewozi się w stanie rozładowanym.",
  },
  {
    id: 160,
    question:
      "W środkach transportu publicznego, służących do przewozu pasażerów, broń do ochrony osobistej, ochrony bezpieczeństwa innych osób oraz mienia: (§2 ust. 2 rozporządzenia w sprawie przewożenia broni i amunicji środkami transportu publicznego)",
    answers: {
      a: "może być załadowana bez wprowadzonego naboju do komory nabojowej i przewożona w stanie zabezpieczonym",
      b: "musi być rozładowana, bez amunicji w komorze nabojowej i w magazynkach oraz przewożona w stanie zabezpieczonym",
      c: "może być załadowana z wprowadzonym nabojem do komory nabojowej i przewożona w stanie zabezpieczonym",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ broń do ochrony może być załadowana, ale nie w komorze nabojowej.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ nabój nie może być w komorze nabojowej.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ broń do ochrony może być załadowana, ale bez wprowadzonego naboju do komory.",
  },
  {
    id: 161,
    question:
      "Amunicję przewozi się środkami transportu publicznego: (§3 ust. 1 rozporządzenia w sprawie przewożenia broni i amunicji środkami transportu publicznego)",
    answers: {
      a: "przy zachowaniu niezbędnych wymogów bezpieczeństwa, wykluczających możliwość przypadkowej eksplozji, w ilości do 200 sztuk",
      b: "przy zachowaniu niezbędnych wymogów bezpieczeństwa, wykluczających możliwość przypadkowej eksplozji, w ilości uzasadnionej potrzebami osoby przewożącej",
      c: "odpowiedzi a. i b. są nieprawidłowe",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ limit amunicji zależy od potrzeb osoby przewożącej.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ przewożenie jest możliwe przy spełnieniu wymogów bezpieczeństwa.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ ilość amunicji powinna być uzasadniona potrzebami osoby przewożącej.",
  },
  {
    id: 162,
    question:
      "Amunicję w środkach transportu przewozi się: (§3 ust. 2 rozporządzenia w sprawie przewożenia broni i amunicji środkami transportu publicznego)",
    answers: {
      a: "w opakowaniach fabrycznych przeznaczonych do sprzedaży detalicznej lub w pudełkach i pojemnikach, w sposób uniemożliwiający uderzenie w spłonkę naboju",
      b: "w magazynkach nabojowych",
      c: "przewożenie amunicji w środkach transportu jest zabronione",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ amunicja nie może być przewożona w magazynkach nabojowych.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ przewożenie amunicji jest dozwolone w odpowiednich opakowaniach.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ amunicja musi być przewożona w opakowaniach fabrycznych lub pudełkach uniemożliwiających uderzenie w spłonkę.",
  },
  {
    id: 163,
    question:
      "Broń i amunicję w pasażerskich statkach powietrznych przewozi się: (§5 rozporządzenia w sprawie przewożenia broni i amunicji środkami transportu publicznego)",
    answers: {
      a: "w kasetce spełniającej wymagania co najmniej klasy S1 według normy PN-EN 14450",
      b: "w bagażu podręcznym, informując o powyższym fakcie kapitana statku",
      c: "w lukach bagażowych lub w miejscu wskazanym przez przewoźnika, jako bagaż rejestrowany, do którego pasażerowie nie mają dostępu",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ broń i amunicja muszą być przewożone w lukach bagażowych, a nie w kasetkach.",
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ bagaż podręczny nie jest odpowiedni do przewozu broni.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ broń i amunicja są przewożone w lukach bagażowych lub miejscach wskazanych przez przewoźnika.",
  },
  {
    id: 164,
    question:
      "Przesyłanie broni lub amunicji za pośrednictwem operatorów świadczących usługi pocztowe jest: (art. 36 uobia)",
    answers: {
      a: "zabronione",
      b: "dozwolone o ile świadczą oni tego rodzaju usługi",
      c: "dopuszczalne za zgodą właściwego organu Policji",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ przesyłanie broni przez operatorów świadczących usługi pocztowe jest dozwolone.",
      b: "Odpowiedź 'b' jest poprawna, ponieważ przesyłanie broni lub amunicji jest dozwolone, jeśli operator świadczy tego rodzaju usługi.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ zgoda Policji nie jest wymagana w tym przypadku.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ przesyłanie broni lub amunicji za pośrednictwem operatorów świadczących usługi pocztowe jest dozwolone, jeśli świadczą oni takie usługi.",
  },
  {
    id: 165,
    question:
      "Przywóz broni i amunicji, z państw niebędących państwami członkowskimi Unii Europejskiej, przez obywateli polskich wymaga: (art. 37 ust. 1 uobia)",
    answers: {
      a: "uprzedniego wydania zaświadczenia przez właściwego konsula Rzeczypospolitej Polskiej",
      b: "uprzedniego wydania zgody właściwego organu Policji",
      c: "poświadczenia uprzedniej zgody przewozowej i zgody przewozowej",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ zaświadczenie konsula nie jest wymagane.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ zgoda przewozowa nie jest poświadczeniem.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ przywóz broni wymaga uprzedniej zgody właściwego organu Policji.",
  },
  {
    id: 166,
    question:
      "Osobom deklarującym zakup broni palnej lub amunicji w innym państwie członkowskim Unii Europejskiej właściwy terytorialnie komendant wojewódzki Policji, na ich wniosek: (art. 37a uobia)",
    answers: {
      a: "poświadcza zgodę przewozową",
      b: "poświadcza uprzednią zgodę przewozową",
      c: "wydaje zaświadczenie uprawniające do nabycia broni",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ zgoda przewozowa wymaga uprzedniego poświadczenia.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ wydaje się uprzednią zgodę, a nie zaświadczenie o nabyciu broni.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ komendant wojewódzki poświadcza uprzednią zgodę przewozową.",
  },
  {
    id: 167,
    question:
      "Wywóz broni i amunicji do państwa niebędącego państwem członkowskim Unii Europejskiej przez obywateli polskich wymaga: (art. 38 ust. 1 uobia)",
    answers: {
      a: "zaświadczenia wydanego przez właściwego konsula Rzeczypospolitej Polskiej",
      b: "uzyskaniu zgody właściwego organu państwa docelowego",
      c: "zgody właściwego organu Policji",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ zaświadczenie konsula nie jest wymagane.",
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ zgoda państwa docelowego nie wystarczy.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ wywóz broni i amunicji wymaga zgody właściwego organu Policji.",
  },
  {
    id: 168,
    question:
      "Wywóz broni i amunicji za granicę przez obywateli polskich nie wymaga zgody właściwego organu Policji w przypadku: (art. 38 ust. 2 uobia)",
    answers: {
      a: "wyjazdu w celach turystycznych, na okres nie dłuższy niż 90 dni",
      b: "wydania Europejskiej karty broni palnej, uprawniającej do wywozu broni na terytorium państw członkowskich Unii Europejskiej",
      c: "wydania legitymacji osoby dopuszczonej do posiadania broni",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ wyjazd turystyczny nie jest wyjątkiem.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ legitymacja nie wystarcza.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ Europejska karta broni palnej pozwala na wywóz broni na terytorium UE.",
  },
  {
    id: 169,
    question:
      "Komendant wojewódzki Policji odmawia poświadczenia uprzedniej zgody przewozowej i zgody przewozowej, jeżeli: (art. 43a uobia)",
    answers: {
      a: "zachodzą okoliczności uzasadniające cofnięcie pozwolenia na broń",
      b: "nie uiszczono opłaty skarbowej za ich poświadczenie",
      c: "odpowiedzi a. i b. są prawidłowe",
    },
    correct: "a",
    explain: {
      a: "Odpowiedź 'a' jest poprawna, ponieważ cofnięcie zgody przewozowej następuje, gdy są okoliczności cofnięcia pozwolenia na broń.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ brak uiszczenia opłaty skarbowej nie został wymieniony jako przyczyna odmowy.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ jedynie okoliczności cofnięcia pozwolenia są podstawą odmowy.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zgoda przewozowa może być odmówiona w przypadku okoliczności cofnięcia pozwolenia na broń.",
  },
  {
    id: 170,
    question:
      "Broń palna oraz inna broń zdolna do rażenia celów na odległość może być używana w celach szkoleniowych i sportowych: (art. 45 uobia)",
    answers: {
      a: "z dala od skupisk ludzkich",
      b: "na prywatnych posesjach",
      c: "tylko na strzelnicach",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ broń musi być używana wyłącznie na strzelnicach.",
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ używanie broni na prywatnych posesjach jest zabronione.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ broń do celów szkoleniowych i sportowych może być używana tylko na strzelnicach.",
  },
  {
    id: 171,
    question:
      "Strzelnice powinny być zlokalizowane, zbudowane i zorganizowane w sposób: (art. 46 ust. 1 uobia)",
    answers: {
      a: "nienaruszający wymogów związanych z ochroną środowiska",
      b: "wykluczający możliwość wydostania się poza ich obręb pocisku wystrzelonego z broni ze stanowiska strzeleckiego w sposób zgodny z regulaminem strzelnicy",
      c: "odpowiedzi a. i b. są prawidłowe",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest prawidłowa, ponieważ ochrona środowiska to jeden z kluczowych wymogów.",
      b: "Odpowiedź 'b' jest prawidłowa, ponieważ strzelnice muszą zapewniać bezpieczeństwo użytkowników i otoczenia.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ strzelnice muszą spełniać zarówno wymogi ochrony środowiska, jak i bezpieczeństwa.",
  },
  {
    id: 172,
    question:
      "Szczegółowe zasady zachowania bezpieczeństwa na strzelnicy określa: (art. 46 ust. 2 uobia)",
    answers: {
      a: "regulamin strzelnicy",
      b: "statut strzelnicy",
      c: "prowadzący strzelanie",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ statut nie reguluje zasad bezpieczeństwa.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ prowadzący strzelanie nie tworzy zasad, tylko egzekwuje regulamin.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ zasady bezpieczeństwa na strzelnicy określa regulamin.",
  },
  {
    id: 173,
    question:
      "Za bezpieczeństwo użytkowników strzelnicy oraz osób im towarzyszących odpowiada: (Rozdział 1 ust. 1 wzorcowego regulaminu bezpiecznego funkcjonowania strzelnic)",
    answers: {
      a: "właściciel strzelnicy",
      b: "zarządca strzelnicy",
      c: "prowadzący strzelanie",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ odpowiedzialność za bezpieczeństwo spoczywa na prowadzącym strzelanie.",
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ zarządca nie jest bezpośrednio odpowiedzialny za bezpieczeństwo podczas strzelania.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ to prowadzący strzelanie odpowiada za bezpieczeństwo użytkowników.",
  },
  {
    id: 174,
    question:
      "Stanowiska strzeleckie dla osób korzystających ze strzelnicy: (Rozdział 1 ust. 1 wzorcowego regulaminu bezpiecznego funkcjonowania strzelnic)",
    answers: {
      a: "wyznacza prowadzący strzelanie",
      b: "osoby korzystające ze strzelnicy wyznaczają sobie same",
      c: "wyznacza właściciel strzelnicy",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ osoby korzystające nie mają prawa samodzielnie wyznaczać stanowisk.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ wyznaczanie stanowisk jest zadaniem prowadzącego strzelanie.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ prowadzący strzelanie wyznacza stanowiska strzeleckie.",
  },
  {
    id: 175,
    question:
      "Osobom towarzyszącym osobom korzystającym ze strzelnicy: (Rozdział 1 ust. 2 wzorcowego regulaminu bezpiecznego funkcjonowania strzelnic)",
    answers: {
      a: "zabrania się przebywania na terenie strzelnicy",
      b: "zabrania się wchodzenia na stanowiska strzeleckie oraz styczności z bronią",
      c: "zabrania się wnoszenia jedzenia i picia na teren strzelnic",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ osoby towarzyszące mogą przebywać na strzelnicy, ale z ograniczeniami.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ regulamin bardziej dotyczy kwestii bezpieczeństwa.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ osobom towarzyszącym zabrania się wchodzenia na stanowiska strzeleckie i styczności z bronią.",
  },
  {
    id: 176,
    question:
      "Używanie broni innych osób korzystających ze strzelnicy jest: (Rozdział 1 ust. 2 wzorcowego regulaminu bezpiecznego funkcjonowania strzelnic)",
    answers: {
      a: "zabronione",
      b: "zabronione bez zgody prowadzącego strzelanie",
      c: "zabronione bez zgody jej użytkownika",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ użytkowanie broni innej osoby jest możliwe za zgodą jej właściciela.",
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ wymagana jest zgoda użytkownika, a nie prowadzącego.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ użytkowanie broni innej osoby wymaga zgody jej użytkownika.",
  },
  {
    id: 177,
    question:
      "Spożywanie alkoholu lub używanie środków odurzających oraz przebywanie osób będących pod ich wpływem na strzelnicy jest: (Rozdział 1 ust. 2 wzorcowego regulaminu bezpiecznego funkcjonowania strzelnic)",
    answers: {
      a: "dozwolone pod warunkiem wynajęcia strzelnicy przez zorganizowaną grupę osób",
      b: "dozwolone za zgodą właściciela strzelnicy",
      c: "zabronione",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ wynajęcie strzelnicy nie upoważnia do spożywania alkoholu.",
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ zgoda właściciela nie umożliwia takich działań.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ spożywanie alkoholu lub używanie środków odurzających na strzelnicy jest zabronione.",
  },
  {
    id: 178,
    question:
      "Na strzelnicy, wyjmowanie broni odbywa się wyłącznie na stanowisku strzeleckim lub treningowym tylko: (Rozdział 2 ust. 2 wzorcowego regulaminu bezpiecznego funkcjonowania strzelnic)",
    answers: {
      a: "na polecenie prowadzącego strzelanie lub trening strzelecki",
      b: "za zgodą właściciela strzelnicy",
      c: "za zgodą zarządcy strzelnicy",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ wyjmowanie broni wymaga polecenia prowadzącego strzelanie.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ zarządca strzelnicy nie ma decydującego wpływu na wyjmowanie broni podczas treningów.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ broń można wyjmować wyłącznie na polecenie prowadzącego strzelanie.",
  },
  {
    id: 179,
    question:
      "Na strzelnicy, strzelanie rozpoczyna się wyłącznie na komendę: (Rozdział 2 ust. 4 wzorcowego regulaminu bezpiecznego funkcjonowania strzelnic)",
    answers: {
      a: "właściciela strzelnicy",
      b: "prowadzącego strzelanie",
      c: "zarządcy strzelnicy",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ to prowadzący strzelanie, a nie właściciel, wydaje komendę.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ zarządca nie odpowiada za bezpośrednie komendy strzelania.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ strzelanie rozpoczyna się wyłącznie na komendę prowadzącego strzelanie.",
  },
  {
    id: 180,
    question:
      "Na strzelnicy, zakończenie strzelania zgłasza się: (Rozdział 2 ust. 5 wzorcowego regulaminu bezpiecznego funkcjonowania strzelnic)",
    answers: {
      a: "zakończenia strzelania nie zgłasza się",
      b: "osobie znajdującej się na sąsiadującym stanowisku strzeleckim",
      c: "prowadzącemu strzelanie",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ zakończenie strzelania musi być zgłaszane.",
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ zgłasza się prowadzącemu, a nie osobie na sąsiadującym stanowisku.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ zakończenie strzelania zgłasza się prowadzącemu strzelanie.",
  },
  {
    id: 181,
    question:
      "Na strzelnicy, po zakończeniu strzelania: (Rozdział 2 ust. 6 wzorcowego regulaminu bezpiecznego funkcjonowania strzelnic)",
    answers: {
      a: "broń rozładowuje się i przedstawia do kontroli prowadzącemu strzelanie",
      b: "broń rozładowuje się i chowa do kabury",
      c: "broń rozładowuje się i pozostawia na stanowisku strzeleckim",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ broń musi zostać przedstawiona prowadzącemu do kontroli po zakończeniu strzelania.",
      c: "Odpowiedź 'c' jest niepoprawna, broń nie powinna być pozostawiana na stanowisku.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ broń musi zostać rozładowana i przedstawiona do kontroli prowadzącemu strzelanie.",
  },
  {
    id: 182,
    question:
      "Na strzelnicy, po zakończeniu strzelania, rozładowaniu broni i przedstawieniu jej prowadzącemu strzelanie: (Rozdział 2 ust. 6 wzorcowego regulaminu bezpiecznego funkcjonowania strzelnic)",
    answers: {
      a: "podchodzi się do tarcz",
      b: "opuszcza się stanowisko strzeleckie z bronią z otwartą komorą nabojową",
      c: "opuszcza się stanowisko strzeleckie pozostawiając broń na stanowisku",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, należy opuścić stanowisko zgodnie z procedurą.",
      c: "Odpowiedź 'c' jest niepoprawna, broń nie powinna być pozostawiana na stanowisku.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ po rozładowaniu broni należy opuścić stanowisko z otwartą komorą nabojową.",
  },
  {
    id: 183,
    question:
      "Na strzelnicy, podczas strzelania, komendę „STOP” może wydać: (Rozdział 3 ust. 4 wzorcowego regulaminu bezpiecznego funkcjonowania strzelnic)",
    answers: {
      a: "wyłącznie prowadzący strzelanie",
      b: "prowadzący strzelanie lub inna osoba",
      c: "prowadzący strzelanie lub zarządca strzelnicy",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ każda osoba zauważająca niebezpieczeństwo może wydać komendę.",
      c: "Odpowiedź 'c' jest niepełna, ponieważ nie tylko zarządca, ale także inne osoby mogą wydać komendę.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ komendę 'STOP' może wydać prowadzący strzelanie lub inna osoba w przypadku zagrożenia.",
  },
  {
    id: 184,
    question:
      "Na strzelnicy, podczas strzelania, po komendzie „STOP”: (Rozdział 3 ust. 4 wzorcowego regulaminu bezpiecznego funkcjonowania strzelnic)",
    answers: {
      a: "strzelający bezzwłocznie przerywają strzelanie",
      b: "strzelający przerywają strzelanie po wyczerpaniu amunicji w magazynku",
      c: "strzelający rozładowują broń i przedstawiają ją prowadzącemu strzelanie",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, przerwanie strzelania powinno nastąpić natychmiast.",
      c: "Odpowiedź 'c' jest częściowo prawidłowa, jednak najważniejsze jest natychmiastowe przerwanie strzelania.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ po komendzie 'STOP' należy natychmiast przerwać strzelanie.",
  },
  {
    id: 185,
    question:
      "Kto porzuca broń palną lub amunicję, która pozostaje w jego dyspozycji, podlega: (art. 50 uobia)",
    answers: {
      a: "wyłącznie karze aresztu albo grzywny",
      b: "grzywnie, karze ograniczenia wolności albo pozbawienia wolności do lat 2",
      c: "wyłącznie karze grzywny",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ porzucenie broni podlega surowszym karom.",
      c: "Odpowiedź 'c' jest niepełna, możliwe są również inne kary.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ porzucenie broni podlega karze grzywny, ograniczenia wolności lub pozbawienia wolności do lat 2.",
  },
  {
    id: 186,
    question:
      "Kto nie dopełnia obowiązku rejestracji broni, podlega: (art. 51 ust. 2 uobia)",
    answers: {
      a: "grzywnie, karze ograniczenia wolności albo pozbawienia wolności do lat 2",
      b: "karze aresztu albo grzywny",
      c: "wyłącznie karze grzywny",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepełna, ponieważ istnieje możliwość surowszych kar.",
      c: "Odpowiedź 'c' jest niepoprawna, gdyż przepisy przewidują surowsze kary.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ nie dopełniając obowiązku rejestracji broni, można podlegać karze grzywny, ograniczenia wolności lub pozbawienia wolności do lat 2.",
  },
  {
    id: 187,
    question:
      "Kto nie dopełnia obowiązku zawiadomienia Policji o utracie lub zbyciu innej osobie broni i amunicji do tej broni, podlega: (art. 51 ust. 2 uobia)",
    answers: {
      a: "grzywnie, karze ograniczenia wolności albo pozbawienia wolności do lat 2",
      b: "wyłącznie karze grzywny",
      c: "karze aresztu albo grzywny",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ kara ograniczenia lub pozbawienia wolności nie jest stosowana w tym przypadku.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ kara grzywny nie jest jedyną przewidzianą karą.",
      c: "Odpowiedź 'c' jest poprawna, ponieważ osoba naruszająca ten obowiązek podlega karze aresztu albo grzywny.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ naruszenie obowiązku zawiadomienia Policji skutkuje karą aresztu albo grzywny.",
  },
  {
    id: 188,
    question:
      "Kto nosi broń, znajdując się w stanie po użyciu alkoholu, podlega: (art. 51 ust. 2 uobia)",
    answers: {
      a: "grzywnie, karze ograniczenia wolności albo pozbawienia wolności do lat 2",
      b: "karze aresztu albo grzywny",
      c: "wyłącznie karze grzywny",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ nie przewidziano kary ograniczenia wolności lub pozbawienia wolności.",
      b: "Odpowiedź 'b' jest poprawna, ponieważ osoba nosząca broń po użyciu alkoholu podlega karze aresztu albo grzywny.",
      c: "Odpowiedź 'c' jest nieprawidłowa, ponieważ kara grzywny nie jest jedyną przewidzianą karą.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ naruszenie tego przepisu skutkuje karą aresztu albo grzywny.",
  },
  {
    id: 189,
    question:
      "Kto przechowuje oraz nosi broń i amunicję w sposób umożliwiający dostęp do nich osób nieuprawnionych, podlega: (art. 51 ust. 2 uobia)",
    answers: {
      a: "grzywnie, karze ograniczenia wolności albo pozbawienia wolności do lat 2",
      b: "karze aresztu albo grzywny",
      c: "wyłącznie karze grzywny",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, gdyż możliwe są także inne kary.",
      c: "Odpowiedź 'c' jest niepełna, przepisy przewidują surowsze kary.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ umożliwienie dostępu do broni osobom nieuprawnionym podlega grzywnie, ograniczeniu wolności lub pozbawieniu wolności do lat 2.",
  },
  {
    id: 190,
    question:
      "Kto używa w celach szkoleniowych lub sportowych broni zdolnej do rażenia celów na odległość poza strzelnicami, podlega: (art. 51 ust. 2 uobia)",
    answers: {
      a: "karze aresztu albo grzywny",
      b: "grzywnie, karze ograniczenia wolności albo pozbawienia wolności do lat 2",
      c: "wyłącznie karze grzywny",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepełna, ponieważ używanie broni poza strzelnicami podlega surowszym karom.",
      c: "Odpowiedź 'c' jest niepoprawna, istnieje możliwość surowszych kar.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ używanie broni poza strzelnicami podlega grzywnie, ograniczeniu wolności lub pozbawieniu wolności do lat 2.",
  },
  {
    id: 191,
    question:
      "Kto narusza przepisy regulaminu określającego zasady zachowania bezpieczeństwa na strzelnicy, podlega: (art. 51 ust. 2 uobia)",
    answers: {
      a: "grzywnie, karze ograniczenia wolności albo pozbawienia wolności do lat 2",
      b: "wyłącznie karze grzywny",
      c: "karze aresztu albo grzywny",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ w tym przypadku nie przewidziano kary ograniczenia lub pozbawienia wolności.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ jest przewidziana również kara aresztu.",
      c: "Odpowiedź 'c' jest poprawna, ponieważ naruszenie regulaminu strzelnicy podlega karze aresztu lub grzywny.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ naruszenie przepisów regulaminu strzelnicy podlega karze aresztu albo grzywny.",
  },
  {
    id: 192,
    question:
      "Kto posiada broń, nie mając przy sobie legitymacji posiadacza broni lub Europejskiej karty broni palnej albo innego dokumentu upoważniającego do posiadania broni, podlega (art. 51 ust. 3 uobia)",
    answers: {
      a: "grzywnie, karze ograniczenia wolności albo pozbawienia wolności do lat 2",
      b: "karze aresztu albo grzywny",
      c: "wyłącznie karze grzywny",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest nieprawidłowa, ponieważ kara ograniczenia wolności lub pozbawienia wolności do lat 2 nie jest stosowana w tym przypadku.",
      b: "Odpowiedź 'b' jest nieprawidłowa, ponieważ kara aresztu nie została wymieniona.",
      c: "Odpowiedź 'c' jest poprawna, ponieważ osoba bez odpowiednich dokumentów podlega wyłącznie karze grzywny.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ brak dokumentów upoważniających do posiadania broni skutkuje wyłącznie karą grzywny.",
  },
  {
    id: 193,
    question:
      "Kto posiada broń, nie mając przy sobie legitymacji osoby dopuszczonej do posiadania broni i świadectwa broni, podlega (art. 51 ust. 3 uobia)",
    answers: {
      a: "wyłącznie karze grzywny",
      b: "grzywnie, karze ograniczenia wolności albo pozbawienia wolności do lat 2",
      c: "wyłącznie karze aresztu albo grzywny",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ kara ograniczenia wolności nie jest przewidziana.",
      c: "Odpowiedź 'c' jest zbyt surowa, przepisy mówią tylko o karze grzywny.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ za brak legitymacji dopuszczającej do posiadania broni przewidziana jest tylko kara grzywny.",
  },
  {
    id: 194,
    question:
      "Nie popełnia przestępstwa, kto działając w obronie koniecznej odpiera bezpośredni, bezprawny zamach: (art. 25 kodeksu karnego)",
    answers: {
      a: "na życie, zdrowie, wolność człowieka oraz na mienie wielkiej wartości",
      b: "na jakiekolwiek dobro chronione prawem",
      c: "tylko na życie i zdrowie człowieka",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepełna, ponieważ obrona konieczna może dotyczyć każdego dobra chronionego prawem.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ obrona konieczna dotyczy szerokiego zakresu dóbr, nie tylko życia i zdrowia.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ obrona konieczna może dotyczyć każdego dobra chronionego prawem.",
  },
  {
    id: 195,
    question:
      "Do przekroczenia granic obrony koniecznej może dojść w sytuacji, gdy: (art. 25 kodeksu karnego)",
    answers: {
      a: "działania obronne wyprzedziły zamach",
      b: "dobrem ratowanym nie było życie",
      c: "dobro ratowane było niskiej wartości",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ to nie jest kryterium przekroczenia obrony koniecznej.",
      c: "Odpowiedź 'c' nie odnosi się do przyczyn przekroczenia granic obrony koniecznej.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ przekroczenie granic obrony koniecznej może wystąpić, gdy działania obronne wyprzedzą zamach.",
  },
  {
    id: 196,
    question:
      "Do przekroczenia granic obrony koniecznej może dojść w sytuacji, gdy: (art. 25 kodeksu karnego)",
    answers: {
      a: "dobrem ratowanym nie było życie",
      b: "dobro ratowane było niskiej wartości",
      c: "działania obronne były niewspółmierne do niebezpieczeństwa zamachu",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' nie jest poprawna, wartość życia nie wpływa na przekroczenie granic obrony koniecznej.",
      b: "Odpowiedź 'b' jest błędna, wartość ratowanego dobra nie ma wpływu na przekroczenie granic obrony.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ przekroczenie granic obrony koniecznej może wystąpić, gdy działania obronne są niewspółmierne do zagrożenia.",
  },
  {
    id: 197,
    question:
      "Kto bez wymaganego zezwolenia wyrabia broń palną, podlega: (art. 263 kodeksu karnego)",
    answers: {
      a: "karze pozbawienia wolności od roku do lat 10",
      b: "grzywnie, karze ograniczenia wolności albo pozbawienia wolności do lat 2",
      c: "karze aresztu albo grzywny",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepoprawna, ponieważ wyrabianie broni bez zezwolenia podlega surowszym karom.",
      c: "Odpowiedź 'c' jest niepełna, gdyż przepisy przewidują surowsze kary.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ wyrabianie broni bez zezwolenia podlega karze pozbawienia wolności od roku do lat 10.",
  },
  {
    id: 198,
    question:
      "Kto bez wymaganego zezwolenia posiada broń palną lub amunicję, podlega: (art. 263 kodeksu karnego)",
    answers: {
      a: "grzywnie, karze ograniczenia wolności albo pozbawienia wolności do lat 2",
      b: "karze aresztu albo grzywny",
      c: "karze pozbawienia wolności od 6 miesięcy do lat 8",
    },
    correct: "c",
    explain: {
      a: "Odpowiedź 'a' jest niepoprawna, ponieważ posiadanie broni bez zezwolenia podlega surowszym karom.",
      b: "Odpowiedź 'b' jest niepełna, gdyż przepisy przewidują możliwość pozbawienia wolności.",
    },
    rightAnswer:
      "Odpowiedź 'c' jest poprawna, ponieważ posiadanie broni bez zezwolenia podlega karze pozbawienia wolności od 6 miesięcy do lat 8.",
  },
  {
    id: 199,
    question:
      "Kto, mając zezwolenie na posiadanie broni palnej lub amunicji, udostępnia lub przekazuje ją osobie nieuprawnionej, podlega: (art. 263 kodeksu karnego)",
    answers: {
      a: "grzywnie, karze ograniczenia wolności albo pozbawienia wolności do lat 2",
      b: "karze aresztu albo grzywny",
      c: "grzywnie",
    },
    correct: "a",
    explain: {
      b: "Odpowiedź 'b' jest niepełna, gdyż przepisy przewidują surowsze kary.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ udostępnianie broni bez uprawnień podlega także karze pozbawienia wolności.",
    },
    rightAnswer:
      "Odpowiedź 'a' jest poprawna, ponieważ udostępnianie broni osobie nieuprawnionej podlega grzywnie, karze ograniczenia wolności albo pozbawienia wolności do lat 2.",
  },
  {
    id: 200,
    question:
      "Kto nieumyślnie powoduje utratę broni palnej lub amunicji, która zgodnie z prawem pozostaje w jego dyspozycji, podlega: (art. 263 kodeksu karnego)",
    answers: {
      a: "wyłącznie karze aresztu albo grzywny",
      b: "grzywnie, karze ograniczenia wolności albo pozbawienia wolności do roku",
      c: "grzywnie",
    },
    correct: "b",
    explain: {
      a: "Odpowiedź 'a' jest niepełna, przepisy przewidują także możliwość pozbawienia wolności.",
      c: "Odpowiedź 'c' jest niepoprawna, ponieważ mogą być także nałożone surowsze kary.",
    },
    rightAnswer:
      "Odpowiedź 'b' jest poprawna, ponieważ nieumyślne spowodowanie utraty broni podlega grzywnie, karze ograniczenia wolności albo pozbawienia wolności do roku.",
  },
];

export default examQuestions;
